{
  "landingCleanup": {
    "eyebrow": "Your first little good deed",
    "demo": "Give it a try",
    "unit": "XP",
    "experience": "{{count}} experience points in the demo",
    "paper": "Pick up the paper and drag it into the bin",
    "hint": "Drag with your mouse · Use your finger on mobile",
    "keyboard": "Press Enter or Space to pick it up and put it in the bin.",
    "photoCaption": "Your good deed, captured",
    "photoDone": "Photo captured",
    "uploadCaption": "Uploading your good deed …",
    "rewardCaption": "Small deed. Great feeling.",
    "restart": "Restart",
    "continue": "Discover Goodvale",
    "status": {
      "ready": "Drag the paper into the bin.",
      "dragging": "Over to the bin!",
      "release": "Let go – nicely done!",
      "photo": "A photo captures your good deed.",
      "upload": "Your deed is on its way to Goodvale.",
      "complete": "Your effort makes a difference."
    },
    "note": "Interactive demo · Real deeds earn XP after approval."
  },
  "partnerTargeting": {
    "summary": "Your audience",
    "reset": "Reset selection",
    "noRestrictions": "All users with access to partner offers can use your offer.",
    "experience": "How much experience is needed?",
    "experienceHelp": "Choose a minimum rank. All higher ranks also qualify.",
    "everyone": "Everyone",
    "noMinimum": "No minimum rank",
    "fromXp": "from {{value}} XP",
    "rankLink": "View the rank system ↗",
    "ranks": { "E": "Explorer", "D": "Pioneer", "C": "Guardian", "B": "Master", "A": "Elite", "S": "Legend" },
    "trust": "How much trust is needed?",
    "trustHelp": "Karma reflects trust in a user. Choose a tier instead of a number.",
    "platformAccess": "No additional minimum",
    "fromKarma": "from +{{value}} karma",
    "customKarma": "Custom minimum: {{value}} karma · adjust below",
    "category": "Experience in a specific category",
    "categoryHelp": "Optional: reach users who are active in a particular area.",
    "categoryToggle": "Require category experience",
    "selectedCategory": "Selected category",
    "change": "Change",
    "categoryLevel": "Experience in the category",
    "categoryLevelValue": "From level {{level}} · {{xp}} category XP required",
    "categoryStages": { "0": "First experience", "1": "Advanced", "2": "Specialised" },
    "fromLevel": "from level {{value}}",
    "customCategoryLevel": "Custom category level: {{value}} · adjust below",
    "event": "Participation in an activity",
    "eventHelp": "Optional: require a verified good deed for a particular activity.",
    "eventToggle": "Require participation",
    "noEvents": "No activities are currently available.",
    "selectEvent": "Which activity?",
    "savedEvent": "Saved activity",
    "advanced": "Advanced settings",
    "advancedHelp": "Add exact minimum values if needed. They apply alongside your selections above.",
    "customActive": "Custom values active",
    "minLevel": "Minimum overall level",
    "minGlobalExperience": "Minimum overall XP",
    "minKarma": "Custom minimum karma",
    "minCategoryLevel": "Custom minimum category level",
    "minCategoryExperience": "Minimum category XP",
    "noExtraMinimum": "No additional minimum",
    "rankSummary": "Rank {{rank}} and above",
    "karmaSummary": "Karma from {{value}}",
    "levelValue": "Level {{value}}+",
    "minLevelSummary": "Overall level {{value}}+",
    "minGlobalExperienceSummary": "Overall XP {{value}}+",
    "minCategoryExperienceSummary": "Category XP {{value}}+",
    "reach": "Percentage of qualifying users",
    "audienceShort": "Your reach updates automatically as you adjust your selections.",
    "howCounted": "How is the audience counted?"
  },
  "partnerPass": {
    "eyebrow": "Verification complete",
    "title": "Pass successfully verified",
    "subtitle": "Customer details and personal benefits at a glance.",
    "profile": "Verified profile",
    "valid": "Valid pass",
    "noGuild": "No guild",
    "karma": "Karma",
    "security": "Signature checked · Timestamp valid",
    "benefitsEyebrow": "Personal benefits",
    "benefits": "Offers & bonuses",
    "available_one": "{{count}} offer is ready to redeem.",
    "available_other": "{{count}} offers are ready to redeem.",
    "eligible": "Ready to redeem",
    "unavailable": "Unavailable",
    "discount": "discount",
    "emptyTitle": "No offers yet",
    "emptyDescription": "There are currently no offers for this pass.",
    "frequency": {
      "Unlimited": "Unlimited",
      "Daily": "Daily",
      "Weekly": "Weekly",
      "Monthly": "Monthly",
      "Yearly": "Yearly",
      "Once": "Once",
      "OncePerDay": "Once a day",
      "OncePerWeek": "Once a week",
      "OncePerMonth": "Once a month",
      "OnceEver": "Once",
      "EveryXDays": "At regular intervals"
    }
  },
  "partnerApprovalEmail": {
    "deliveryFailed": "The partner was approved, but the confirmation email could not be sent. Please check email delivery and inform the partner."
  },
  "partnerOfferSetup": {
    "redemptionMode": "Single or repeat redemption",
    "onceTitle": "Once",
    "multiple": "Multiple times",
    "multipleHelp": "Users can redeem the offer repeatedly. Set the frequency and limits below.",
    "audienceLoading": "Calculating audience …",
    "audienceError": "Audience currently unavailable",
    "audienceCount": "{{qualified}} of {{total}} users qualify",
    "audienceHelp": "Currently approved platform users with access to partner offers. All selected requirements must be met together. Redemption frequency, quotas and the offer validity period are not included here.",
    "rankHelp": "Ranks reflect accumulated experience: F is the starting rank, followed by E, D, C, B, A and S. The selected rank and all higher ranks qualify.",
    "rankLink": "Learn about ranks and progression ↗",
    "progressHelp": "Level and total XP describe overall progress. Category level and category XP apply only to the selected category. Empty fields do not further restrict the audience.",
    "karmaHelp": "Karma describes trust in a user. {{neutral}}: 0; {{honorable}}: from {{honorableValue}}; {{trusted}}: from {{trustedValue}}; {{veryTrusted}}: from {{veryTrustedValue}}; {{exemplary}}: from {{exemplaryValue}}. Partner offers require karma above {{restriction}}.",
    "once": "Once per user",
    "onceHelp": "Each user can redeem this offer once in total. No repeat frequency applies."
  },
  "partnerDiscovery": {
    "tab_available": "Available",
    "tab_history": "History",
    "view": "View",
    "title": "Partners",
    "available": "Available to me",
    "description": "You can currently use these partner offers. Rank, level, karma, category progress, achievements, validity and past redemptions are taken into account. Availability is checked again when redeeming.",
    "all": "All offers",
    "both": "On site & digital",
    "history": "Redemption history",
    "details": "View offer at partner",
    "validUntil": "Valid until {{date}}",
    "count_one": "{{count}} available offer",
    "count_other": "{{count}} available offers",
    "error": "Your available partner offers could not be loaded.",
    "empty": "No offers currently available to you",
    "emptyHint": "No active offer currently meets your requirements and redemption limits. Check back later.",
    "noResults": "No matching offers"
  },
  "redemptionHistory": {
    "title": "Redemptions",
    "subtitle": "Your partner offers",
    "description": "Find your redeemed benefits and digital vouchers here.",
    "map": "Discover partners on the map",
    "search": "Search partner or offer",
    "channel": "Redemption type",
    "all": "All redemptions",
    "onsite": "On site",
    "digital": "Digital",
    "copied": "Voucher code copied.",
    "copyError": "Could not copy. Please select and copy the code.",
    "loading": "Loading redemptions …",
    "error": "Your redemptions could not be loaded.",
    "retry": "Try again",
    "empty": "No redemptions yet",
    "emptyHint": "Discover partners on the world map and redeem your first offer.",
    "noResults": "No matching redemptions",
    "adjustFilters": "Try changing your search or filter.",
    "count_one": "{{count}} redemption",
    "count_other": "{{count}} redemptions",
    "cancelled": "Cancelled",
    "confirmed": "Redeemed",
    "code": "Your voucher code",
    "copy": "Copy code",
    "showCode": "Show code",
    "hideCode": "Hide code",
    "shop": "Open webshop",
    "more": "Show more",
    "limit": "Showing your latest 500 redemptions."
  },
  "heroic_approval": {
    "title": "Good deed confirmed!",
    "message": "Your good deed has been reviewed and confirmed. These rewards have been credited to you:",
    "category": "Category",
    "performed_at": "Completed on",
    "milestones": "New category milestones",
    "category_level": "Category level {{level}} reached",
    "badge_label": "{{category}} badge, level {{level}}",
    "continue": "Continue",
    "setting": "Show popups for confirmed good deeds"
  },
  "category_milestones": {
    "titles": {
      "MOBILITY_OUTDOOR": [
        "Path Friend",
        "Way Companion",
        "Pathfinder",
        "Trailblazer",
        "Wayfinder",
        "Keeper of the Paths",
        "North Star of the Community"
      ],
      "HEALTH_WELLNESS": [
        "Source of Strength",
        "Everyday Supporter",
        "Wellbeing Companion",
        "Keeper of Wellbeing",
        "Source of Hope",
        "Anchor of Everyday Life",
        "Heart of Care"
      ],
      "ENTERTAINMENT_GASTRO": [
        "Friendly Guest",
        "Host",
        "Mood Maker",
        "Bridge Builder",
        "Soul of Connection",
        "Keeper of Community Gatherings",
        "Center of Connection"
      ],
      "HARDWARE_FITNESS": [
        "Movement Friend",
        "Training Companion",
        "Motivator",
        "Driving Force",
        "Strength Giver",
        "Keeper of Movement",
        "Tireless Drive"
      ],
      "ECO_NATURE": [
        "Nature Friend",
        "Nature Companion",
        "Environment Keeper",
        "Keeper of the Green",
        "Voice of Nature",
        "Guardian of Habitats",
        "Root of the World"
      ],
      "TECH_EDUCATION": [
        "Curious Mind",
        "The Knowing",
        "Learning Companion",
        "Knowledge Sharer",
        "Bridge to Knowledge",
        "Keeper of Learning",
        "Beacon of Knowledge"
      ],
      "CRAFTING_REPAIR": [
        "Tinkerer",
        "Craft Apprentice",
        "Tool Expert",
        "Keeper of Things",
        "Master Craftsman",
        "Keeper of Craft",
        "Soul of Things"
      ],
      "FOOD_GROCERIES": [
        "Kitchen Helper",
        "Apprentice Cook",
        "Local Supplier",
        "Keeper of the Table",
        "Heart of Provision",
        "Keeper of the Harvest",
        "Legend of Provision"
      ],
      "LOGISTICS_RETAIL": [
        "Swift Courier",
        "Supply Courier",
        "Local Merchant",
        "Coordinator of Routes",
        "Pillar of Provision",
        "Keeper of Trade Routes",
        "Soul of Provision"
      ],
      "SOCIAL_COMMUNITY": [
        "Kind Soul",
        "Organizer",
        "Pillar of the Community",
        "Connector of Hearts",
        "Heart of the Community",
        "Keeper of Togetherness",
        "Soul of the Community"
      ]
    },
    "collection": "Category titles & badges",
    "possible_titles": "Available titles",
    "active": "Profile title",
    "none": "No title",
    "clear": "Remove title",
    "select": "Show on profile",
    "selected": "Selected",
    "locked": "Locked",
    "level": "Level {{level}}",
    "unlocked_count": "{{count}} of 7 unlocked",
    "save_error": "Could not save your title."
  },
  "level_up": {
    "eyebrow": "A new milestone",
    "level": "Level",
    "level_label": "Level {{level}} reached",
    "title": "Level up!",
    "message": "Your character has reached level {{level}}! Thank you for making a difference in our community, our world, and Goodvale. Your new level may give you access to more partner rewards. See what partners near you have to offer!",
    "continue": "Let’s go!",
    "find_partners": "Explore nearby partners",
    "setting_hint": "Shows a popup when your character reaches a new level."
  },
  "profile_identity": {
    "abilities": "Your abilities & bonuses"
  },
  "adventureFlow": {
    "kicker": "How Goodvale works",
    "title": "Three steps to progress",
    "steps": [
      {
        "title": "Do good",
        "body": "Help your community: collect litter, support neighbours or share your knowledge. Small everyday acts of kindness count too."
      },
      {
        "title": "Submit your deed",
        "body": "Describe a good deed you have actually completed in Goodvale and add the required evidence."
      },
      {
        "title": "Get verified",
        "body": "Independent reviewers assess your submission. Once verified, you earn experience points and develop your character."
      }
    ]
  },
  "flyers": {
    "kicker": "Discover & share",
    "meta": "PDF · 1 page · English",
    "download": "Download flyer",
    "open": "Open preview (new tab)",
    "partner": {
      "title": "The partner flyer",
      "body": "Benefits and redemption explained visually on one page. Download the flyer in your language or share it with your team.",
      "alt": "Preview of the Goodvale partner flyer"
    }
  },
  "partnersPage": {
    "nav": "Partners",
    "learnMore": "Become a partner & view the flyer",
    "kicker": "Make a difference together",
    "title": "Become a partner for free. Make the world better together.",
    "register": "Register as a partner for free",
    "benefits": [
      {
        "title": "Reach new customers",
        "body": "Your profile and offers put your business on the map. An attractive benefit can encourage a first visit and give customers a reason to return."
      },
      {
        "title": "Your offer, your rules",
        "body": "Choose a discount, extra or service, along with eligibility, validity and redemption limits. Participation is free; your contribution is the offer you choose to provide."
      },
      {
        "title": "Easy redemption",
        "body": "On site, your team scans the QR pass in the partner portal. Digital offers can be redeemed in the app. Goodvale checks eligibility and records the redemption."
      }
    ],
    "howTitle": "Turn good deeds into a visit",
    "exampleNote": "Illustrative example. You choose the offer and redemption method. Get started after registration and approval.",
    "flyerKicker": "Take it with you & share",
    "flyerTitle": "The partner flyer",
    "flyerBody": "Benefits and redemption explained visually on one page. Download the flyer or open the full-size preview.",
    "flyerMeta": "PDF · 1 page · German · 15 MB",
    "previewAlt": "Preview of the Goodvale partner flyer with benefits and a redemption example",
    "download": "Download flyer",
    "open": "Open PDF (new tab)"
  },
  "class_change": {
    "once": "One-time opportunity",
    "until": "Until {{date}}",
    "deadline": "One-time change available until {{date}}.",
    "saving": "Saving …",
    "retry": "Try again"
  },
  "ui_text": {
    "admin_dashboard": {
      "partner_applications_stat": "Partner applications",
      "no_appeals": "No pending appeals.",
      "no_moderator_applications": "No pending moderator applications.",
      "partner_applications": "Partner applications",
      "all_partners": "All partners",
      "unlock": "Approve",
      "no_partner_applications": "No partner applications are awaiting approval.",
      "recent_users": "Recent users",
      "all_users": "All users",
      "banned": "Banned",
      "active": "Active",
      "no_users": "No new users found.",
      "audit_errors": "Audit log errors & system events",
      "no_audit_entries": "No error or sanction entries."
    },
    "admin_class_category": {
      "no_categories": "No categories available.",
      "cancel": "Cancel",
      "save": "Save",
      "parallel_deed_slot": "Additional concurrent good deed slot",
      "save_perk": "Save perk"
    },
    "partner_offer_editor": {
      "loading_offer": "Loading offer details …",
      "partner_location": "Partner location",
      "place_pin": "Click the map to place the pin",
      "no_restriction": "No restriction",
      "good_deed_requirement": "Approved good deed / quest (optional)",
      "no_requirement": "No requirement",
      "day_interval": "Interval in days (e.g. every 14 days)"
    },
    "guild_members_admin": {
      "loading": "Loading members & applications...",
      "loading_applications": "Loading pending applications...",
      "cancel": "Cancel"
    },
    "guild_branding": {
      "unlock_forge": "Unlock the emblem forge in the shop",
      "save": "Save changes"
    },
    "admin_partners": {
      "all_partners": "All partners",
      "no_pending_applications": "All received partner applications have been reviewed.",
      "all_categories": "All categories",
      "no_partners": "No partner businesses found.",
      "map_location": "Location on map (optional)"
    },
    "guild_detail_misc": {
      "cancel": "Cancel",
      "close": "Close"
    },
    "admin_tribunal_moderators": {
      "reason": "Reason (shared with the user):",
      "cancel": "Cancel"
    },
    "register_misc": {
      "active": "Active"
    },
    "partner_pos_misc": {
      "rank": "RANK",
      "redeeming": "Redeeming..."
    },
    "karma_admin_panel": {
      "cancel": "Cancel",
      "profile": "Profile"
    },
    "admin_user_detail": {
      "back_to_list": "Back to list"
    },
    "login_misc": {
      "welcome_back": "Welcome back"
    },
    "heroic_actions_misc": {
      "next": "Next →",
      "rules_contributions_title": "Documented contributions",
      "rules_contributions_intro": "Describe what you did, when you did it, and its impact. Time and effort and planning and coordination are guides; the final assessment takes place during review.",
      "rules_evidence_title": "Evidence & follow-up questions",
      "rules_slots_title": "Slots & cooldowns",
      "rules_slots_intro": "Individual actions and active group registrations share your slots. Open actions and active cooldowns each occupy a slot. Withdrawal or cancellation releases the slot immediately."
    },
    "landing_misc": {
      "small_deeds_big": "Small deeds. Big"
    },
    "admin_partner_card": {
      "location_recorded": "Location recorded"
    },
    "avatar_uploader_misc": {
      "cancel": "Cancel"
    },
    "submissions_filter_misc": {
      "none": "None"
    }
  },
  "guild_rooms": {
    "change_room": "Change room",
    "navigation": "Guildhouse navigation",
    "content": "Room content",
    "locked": "Not unlocked yet",
    "news": "News",
    "roster": "Members",
    "stammtisch": "Common room",
    "bounties": "Group actions",
    "trophies": "Trophy room",
    "forge": "Emblem forge",
    "design": "Hall style",
    "stats": "Renown & statistics",
    "settings": "Administration"
  },
  "cookie": {
    "title": "Privacy & Tracking Settings",
    "description": "Choose separately whether to enable Umami usage statistics (self-hosted at Hetzner) and Sentry browser diagnostics. Both are optional and initially disabled. You can decline or change your choices later under Privacy.",
    "accept_all": "Allow all",
    "decline_all": "Reject all",
    "settings": "Preferences",
    "save": "Save preferences",
    "privacy_policy": "Privacy Policy",
    "essential_title": "Essential Functions",
    "essential_desc": "Session, language and theme preferences. Always active.",
    "analytics_title": "Umami Analytics (Web Tracking)",
    "analytics_desc": "Page views, referrers and technical browser data to improve Goodvale.",
    "status_enabled": "Enabled",
    "status_disabled": "Disabled",
    "reopen_tooltip": "Adjust cookie & tracking preferences",
    "diagnostics_title": "Sentry (error diagnostics)",
    "diagnostics_desc": "Error reports and technical diagnostics to resolve problems. Selectable independently of Umami.",
    "always_active": "Always active"
  },
  "hero_card": {
    "level": "Level",
    "actions": "Good Deeds",
    "loading": "Loading QR code …",
    "unavailable": "QR code temporarily unavailable",
    "retry": "Try again",
    "refreshes": "Refreshes automatically"
  },
  "dialogs": {
    "close": "Close",
    "cancel": "Cancel",
    "ok": "Got it",
    "confirm": "Confirm",
    "submit": "Submit",
    "reason": "Your reason",
    "placeholder": "Write your reason here …",
    "minimum": "{{current}} / {{count}} characters minimum",
    "alert_title": "Notice",
    "confirm_title": "Confirm action",
    "prompt_title": "Add your reason",
    "motivation": "Your motivation",
    "apply": "Send application",
    "delete_account": "Permanently delete account",
    "confirmation_phrase": "Confirmation phrase"
  },
  "app": {
    "title": "Goodvale"
  },
  "world": {
    "nav": {
      "overview": "Overview",
      "heroic": "Good Deed",
      "events": "Events",
      "chat": "Chat",
      "profile": "Profile"
    }
  },
  "settings": {
    "language": "Language",
    "theme": "Theme"
  },
  "common": {
    "login": "Sign in",
    "register": "Register",
    "novice": "Novice",
    "error": "Could not load the data.",
    "retry": "Try again",
    "refresh": "Refresh",
    "cancel": "Cancel",
    "close": "Close",
    "copy": "Copy",
    "loading": "Loading…",
    "loadMore": "Load more",
    "pagination": "Pages",
    "prev": "Previous",
    "previous": "Previous",
    "next": "Next",
    "latitude": "Latitude",
    "longitude": "Longitude",
    "gps": {
      "notSupported": "GPS is not supported by this browser.",
      "error": "Your location could not be determined.",
      "useCurrent": "Use GPS location"
    }
  },
  "nav": {
    "moderation": "Moderation",
    "map": "Map",
    "faq": "FAQ",
    "help": "Help",
    "logout": "Logout",
    "mechanics": "Mechanics",
    "profile": "My Profile",
    "chats": "Chats",
    "heroic_slots": "My Slots",
    "language": "Language",
    "legal": "Legal & Terms",
    "settings": "Settings",
    "system_config": "System Configuration",
    "heroic_actions": "Good deeds",
    "categories": "Categories"
  },
  "karma": {
    "marker_exemplary": "Anchor of Trust",
    "marker_exemplary_detail": "The highest trust tier starts here.",
    "marker_very_trusted": "Beacon of Hope",
    "marker_very_trusted_detail": "The next positive trust tier starts here.",
    "marker_saint": "Trusted",
    "marker_saint_detail": "The Trusted tier starts here.",
    "marker_honorable": "Reliable",
    "marker_honorable_detail": "The Reliable tier starts here.",
    "marker_neutral": "Neutral",
    "marker_partner": "Partner benefits blocked",
    "marker_suspension": "Account suspension",
    "marker_suspension_detail": "From {{suspension}} for {{months}} calendar month(s).",
    "tier_trusted": "Trusted",
    "tier_trusted_desc": "High trust earned through reliable contributions.",
    "tier_very_trusted": "Beacon of Hope",
    "tier_very_trusted_desc": "You have built considerable trust through consistent contributions.",
    "tier_exemplary": "Anchor of Trust",
    "tier_exemplary_desc": "You have reached the highest trust tier.",
    "tier_honorable": "Reliable",
    "tier_honorable_desc": "Your verified good deeds show that others can count on you.",
    "tier_trusty": "Trusty Companion",
    "tier_neutral": "Neutral Wanderer",
    "tier_warned": "Cautioned",
    "tier_banned": "Account suspended",
    "tier_restricted": "Temporary account suspension",
    "tier_released": "Partner benefits blocked",
    "reason": "Reason / message (5–1000 characters)",
    "saving": "Saving …",
    "search": "Find a person"
  },
  "avatar": {
    "title": "Customize Profile Picture",
    "upload_btn": "Upload New Photo",
    "cropping_hint": "Drag the photo to position it and use the slider to zoom. The visible crop will be saved.",
    "zoom": "Zoom",
    "preview": "Profile crop preview",
    "no_image": "No photo",
    "invalid_file": "Please choose a valid JPG, PNG, or WebP image.",
    "save": "Save",
    "uploading": "Uploading...",
    "success": "Profile picture updated successfully!",
    "error": "Failed to upload profile picture."
  },
  "tavern": {
    "subtitle": "What moves the world.",
    "description": "Find out what's happening on Goodvale: news, current events, and developments in the community.",
    "filterLabel": "Filter posts",
    "filters": {
      "all": "All",
      "news": "News",
      "events": "Events",
      "community": "Community"
    },
    "loadError": "Could not load news.",
    "loading": "Pouring drinks...",
    "detail": {
      "unavailable": "These system news could not be loaded.",
      "footer": "News from GuildWorld"
    },
    "editor": {
      "formatting": "Text formatting",
      "bold": "Bold",
      "italic": "Italic",
      "underline": "Underline",
      "heading": "Heading",
      "bulletList": "Bullet list",
      "orderedList": "Numbered list",
      "quote": "Quote",
      "link": "Link",
      "unlink": "Remove link",
      "undo": "Undo",
      "redo": "Redo",
      "linkUrl": "Link address",
      "apply": "Apply",
      "invalidLink": "Please use https://, http:// or mailto:."
    },
    "admin": {
      "createNews": "Create System News",
      "editNews": "Edit System News",
      "saveChanges": "Save Changes",
      "newsTitle": "System News Title",
      "newsContent": "Announcement content...",
      "publish": "Publish Announcement",
      "publishing": "Publishing...",
      "success": "System news published successfully!",
      "error": "Failed to publish system news.",
      "newsTitlePlaceholder": "e.g. Weekend maintenance",
      "newsContentPlaceholder": "Announcement content…",
      "cancel": "Cancel"
    },
    "feed": {
      "adventurerJoinedTag": "NEW ADVENTURER",
      "heroicActionApproved": "{{name}} had the good deed ‘{{title}}’ verified",
      "heroicActionTag": "Approved good deed",
      "partnerJoined": "Partner {{name}} is now part of Goodvale",
      "systemNewsTag": "System News",
      "partnerJoinedTag": "New Partner",
      "openOnMap": "Show on map",
      "showInCalendar": "Mark in calendar",
      "viewProfile": "View profile"
    },
    "author": "By: {{name}}"
  },
  "guilds": {
    "renownPts": "renown points",
    "page_status": "Page {{current}} of {{total}}",
    "members": "Members",
    "memberStatus": "Member ✓",
    "manageGuild": "Manage",
    "enterGuildhouse": "Enter Guildhouse",
    "decorations": {
      "renown": "Renown stage",
      "stages": {
        "0": "Founded",
        "1": "Recognized",
        "2": "Esteemed",
        "3": "Renowned",
        "4": "Legendary"
      },
      "details": {
        "0": "Wooden Frames & Lanterns",
        "1": "Bronze Embellishments",
        "2": "Carved Stone Arches & Bronze Fittings",
        "3": "Gold Trimmings & Stained Glass",
        "4": "Luminous Runes"
      },
      "forest": "Forest Hall",
      "bronzeFrame": "Bronze Banner Frame",
      "celestial": "Celestial Hall"
    },
    "join": {
      "label": "Join",
      "pending": "Request pending",
      "noUser": "No authenticated user found.",
      "success": "Application submitted successfully!",
      "error": "Failed to join. Please try again."
    },
    "memberBanner": {
      "title": "You are a member of \"{{name}}\"",
      "description": "You are a member of {{name}}. Make a difference together through good deeds!",
      "memberSubtitle": "Glory to your banner! Visit your guildhouse or discover other factions of the world.",
      "guildhouseBtn": "Enter My Guildhouse"
    },
    "createModal": {
      "cancel": "Cancel",
      "descTooLong": "Description may be at most 300 characters.",
      "emblemTitle": "Choose a heraldic emblem",
      "latitudeRequired": "Latitude is required.",
      "invalidLatitude": "Invalid latitude (-90 to 90).",
      "longitudeRequired": "Longitude is required.",
      "invalidLongitude": "Invalid longitude (-180 to 180)."
    },
    "createPage": {
      "subtitle": "Create a new fellowship in the goodvale",
      "description": "Specify the name, philosophy, heraldic emblem, and map location of your new guildhall.",
      "actionsProgress": "{{required}} approved good deeds of your own (current: {{current}})"
    },
    "card_description": "An honorable community in the goodvale.",
    "house_status": "Guildhouse status",
    "house_public": "Public",
    "verwalten": "Manage"
  },
  "share": {
    "title": "Invite Friends",
    "copy_link": "Copy Link",
    "link_copied": "Copied!",
    "via_email": "Invite via Email",
    "via_telegram": "Share via Telegram",
    "via_whatsapp": "Share via WhatsApp",
    "native_share": "Share via other apps",
    "invite_subject": "Invitation to Goodvale",
    "invite_text": "Join Goodvale and make the world a better place! Register here:"
  },
  "pos": {
    "title": "Guildhouse POS & QR Verification",
    "error_empty_token": "Please enter or scan a valid QR code.",
    "verification_failed": "Verification failed.",
    "network_error": "Error communicating with server.",
    "redeem_failed": "Redemption failed.",
    "redeem_error": "Error redeeming offer.",
    "verifying_state": "Verifying cryptographic signature...",
    "align_qr": "Align QR Pass",
    "manual_token_label": "Paste QR Code Manually / Scanner Input",
    "verify_btn": "Verify",
    "verification_failed_title": "Verification Rejected",
    "redeem_success_title": "Offer successfully redeemed!",
    "verified_badge": "PASS VERIFIED • TIMESTAMP VALID",
    "scan_next": "Scan Next Customer",
    "offers_evaluation_title": "Available Offers & Bonuses",
    "redeem_button": "Redeem",
    "standby_title": "Waiting for Scan",
    "camera_active": "OPTICAL CAMERA SCANNER",
    "camera_paused": "SCANNER PAUSED",
    "camera_loading": "Initializing camera …",
    "camera_permission_denied": "Camera access denied or unavailable. Please grant camera permission in your browser.",
    "camera_start_btn": "Enable Camera",
    "camera_start_prompt": "Tap the scanner to start the camera",
    "camera_stop_btn": "Pause Camera",
    "camera_switch_btn": "Switch Camera"
  },
  "qr_pass": {
    "title": "Dynamic Pass QR Code",
    "signed_badge": "Signed (HMAC-SHA256)",
    "validity_label": "Pass Validity",
    "security_hint": "Cryptographically timestamped against screen captures and sharing. Partner businesses scan this code for on-site perks.",
    "refresh_btn": "Renew Code",
    "copy_token": "Copy QR Code",
    "copied": "Copied!",
    "click_to_enlarge": "Click to enlarge",
    "enlarge_btn": "Enlarge",
    "refresh": "Refresh QR Code",
    "enlarge": "Fullscreen",
    "modal_badge": "Official ID",
    "valid_until": "Valid for",
    "anti_tamper": "HMAC Signature verified",
    "close": "Close",
    "loading": "Loading pass …",
    "unavailable": "No valid QR pass available.",
    "retry": "Retry"
  },
  "profile_v2": {
    "loading": "Loading profile …",
    "load_error": "The profile could not be loaded.",
    "show_qr": "Show QR Pass",
    "days_active": "Active days",
    "confirmed_days": "Days with verified good deeds",
    "public_profile": "Public Profile",
    "bio": "Bio",
    "save": "Save",
    "saved": "Profile saved.",
    "save_error": "The profile could not be saved.",
    "messages": "Messages",
    "notifications": "Notifications",
    "language": "Language",
    "theme": "Theme",
    "dark": "Dark",
    "light": "Light",
    "moderator_prompt": "Why would you like to moderate?",
    "moderator_sent": "Application submitted.",
    "moderator_error": "The application could not be submitted.",
    "apply": "Apply",
    "redemptions": "Redeemed Partner Offers",
    "no_redemptions": "No offers redeemed yet.",
    "data_rights": "Privacy",
    "data_rights_help": "Download a machine-readable copy of your data or anonymize your account. You cannot sign in after anonymization; mandatory review and security records remain without your contact details.",
    "export": "Export Data",
    "export_error": "Data export failed.",
    "delete": "Anonymize Account",
    "delete_phrase_prompt": "Type DELETE to confirm.",
    "delete_phrase": "DELETE",
    "delete_phrase_wrong": "The confirmation did not match.",
    "delete_error": "The account could not be anonymized.",
    "change_password": "Change Password",
    "current_password": "Current Password",
    "new_password": "New Password",
    "confirm_password": "Confirm New Password",
    "password_changed": "Password successfully changed.",
    "password_mismatch": "New passwords do not match.",
    "password_min_length": "New password must be at least 8 characters long.",
    "password_change_error": "Failed to change password."
  },
  "map_v2": {
    "legend": "World Map",
    "partners": "Partner Offers",
    "guild_members": "{{count}} members",
    "partner_category": "Partner · {{category}}"
  },
  "chats_v2": {
    "permission_label": "Who can message me?",
    "permission_everyone": "Everyone",
    "permission_nobody": "Nobody",
    "open_profile": "Open {{name}}'s public profile",
    "title": "Direct Messages",
    "empty": "No direct messages yet.",
    "start": "Write the first message.",
    "you": "You",
    "message": "Write a message …",
    "select": "Select a conversation.",
    "load_error": "Messages could not be loaded.",
    "send_error": "The message could not be sent."
  },
  "game_mechanics": {
    "title": "How Goodvale works",
    "decision": {
      "title": "Decision rule",
      "text": "All required votes are collected before the majority decides. A single rejection is final only when exactly one review is required. A 1–1 result with two reviews automatically adds a third tie-break review. The submitter sees no individual votes, only the pending and final status."
    },
    "groups": {
      "title": "Group good deeds"
    },
    "privacy": {
      "title": "Evidence and appeals",
      "text": "Evidence is encrypted, available only to the submitter, assigned reviewers, and admins, access-logged, and deleted after the retention period. A rejection can be appealed within the configured window; an accepted appeal starts a new independent review round."
    },
    "removed": {
      "title": "Deliberately outside the model"
    },
    "ai_abuse": {
      "title": "Fair Play and AI Abuse"
    },
    "karma": {
      "kicker": "TRUST AND CONSEQUENCES",
      "neutral": {
        "range": "0 to {{maximum}}",
        "text": "Partner benefits remain available if the offer's other requirements are met."
      },
      "partner": {
        "range": "{{partner}} to {{partnerEnd}}",
        "title": "Partner benefits blocked",
        "text": "Partner discounts and offers cannot be used."
      },
      "xp": {
        "range": "{{xp}} to {{xpEnd}}"
      },
      "tribunal": {
        "range": "From {{tribunalLoss}}"
      },
      "suspension": {
        "range": "{{suspension}} to {{minimum}}",
        "title": "Temporary account suspension"
      }
    },
    "hero_title": "How <emphasis>Goodvale</emphasis> Works",
    "flow_title": "The Path of a Good Deed",
    "start_title": "Ready for your first good deed?",
    "flow_description": "From voluntary contribution to verified reward: the system is independent, manipulation-proof, and transparent.",
    "flow_kicker": "CLEAR STEPS",
    "principles_kicker": "RULES & COMMUNITY",
    "start_kicker": "YOUR ADVENTURE AWAITS"
  },
  "player_progress": {
    "level_progress": "Level progress",
    "max_short": "Max",
    "max_level_reached": "Maximum level reached",
    "open_statistics": "Open level statistics"
  },
  "level_statistics": {
    "title": "Level statistics",
    "subtitle_short": "Your progress at a glance",
    "back": "Back to overview",
    "loading": "Loading level statistics…",
    "error": "Your level statistics could not be loaded.",
    "retry": "Try again",
    "current_level": "Current level",
    "total_xp": "Total experience",
    "approved_deeds": "Approved good deeds",
    "next_level_title": "Progress to next level",
    "progress_title": "Progress over time",
    "chart_caption": "Experience earned from approved good deeds each month",
    "chart_aria": "Experience earned each month over the last twelve months"
  },
  "slotsPage": {
    "goodContactsReady": "Good Contacts available – use it in My slots",
    "skipCooldown": "Free with Good Contacts",
    "untitledAction": "Good deed",
    "skippingCooldown": "Freeing slot …",
    "skipUsed": "Good Contacts used this week",
    "slotReleased": "Slot released!",
    "overview": "Your overview",
    "title": "My slots",
    "subtitle": "Your open submissions and the next available good deed.",
    "openSubmissions": "Your slots",
    "slot": "Slot {{number}}",
    "free": "Available",
    "createSubmission": "Submit a good deed",
    "tapToStart": "Use slot",
    "submittedAt": "Submitted on",
    "viewSubmission": "View submission",
    "groupActive": "Active group quest",
    "freeAfterCooldown": "This slot becomes available afterwards.",
    "groupStillActive": "Elapsed · quest still active",
    "registeredAt": "Registered on",
    "viewGroup": "View group quest"
  },
  "dashboard_v2": {
    "back": "Dashboard",
    "ready": "Ready",
    "countdown_days": "{{days}}d {{hours}}h",
    "day_short": "d",
    "start_action": "Start good deed",
    "experience": "Experience",
    "next_action_in": "Next good deed",
    "action_slots": "Slots",
    "slots_free": "{{count}} available",
    "slots_full": "All slots occupied",
    "approved_count": "{{count}} approved good deeds",
    "categories_specialization": "Categories & specialization",
    "show_more": "Show more",
    "show_less": "Show less",
    "all_categories": "All categories",
    "level_short": "Lv.",
    "experience_value": "{{value}} experience",
    "until_level": "{{value}} until level {{level}}",
    "level_value": "Lv. {{level}}",
    "change_avatar": "Change profile picture",
    "profile_picture_alt": "Profile picture of {{name}}",
    "change_banner": "Upload a custom banner",
    "upload_error": "The image could not be saved.",
    "action_panel_title": "Your next good deed",
    "action_cta_title": "Ready to make a difference?",
    "action_cta_text": "Document a voluntary good deed and submit clear evidence for independent review.",
    "class_quotes": {
      "SCOUT": "The horizon belongs to those who set out.",
      "MEDIC": "Where hope lives, healing begins.",
      "SOCIAL": "One story connects more than a thousand paths.",
      "TANK": "Strength grows with every repetition.",
      "ENVIRONMENT": "Those who listen to nature find their way.",
      "TECH": "Knowledge opens doors that strength cannot move.",
      "CRAFTER": "Great things are made with patience, fire, and craft.",
      "NUTRITION": "Every discovery begins with a good mixture.",
      "LOGISTICS": "The shortest route is the one no one overlooks.",
      "GUARDIAN": "Honor shows itself where protection is needed."
    },
    "welcome": "Welcome, {{name}}",
    "submit_action": "Submit Good Deed",
    "quick_submission": "Quick submission",
    "quick_actions": "Quick Actions",
    "level": "Level",
    "approved": "Verified",
    "pending": "Under Review",
    "category_progress": "Category Progress",
    "category_level": "Level {{level}}",
    "no_category_progress": "No category progress yet. Your first verified good deed will start it.",
    "recent_actions": "Recent Good Deeds",
    "latest_action": "Latest Good Deed",
    "show_all": "Show All",
    "no_actions": "You have not submitted a good deed yet.",
    "active_events": "Active System Good Deeds",
    "rules_title": "Fair & Voluntary",
    "rules_text": "Rewards reflect personal effort and verifiable impact. No dangerous work, monetary or goods value, or concealed partner assignments.",
    "read_faq": "Read Rules and Privacy",
    "apply_moderator": "Apply as Moderator",
    "moderator_sent": "Your moderator application was submitted.",
    "moderator_error": "The application could not be submitted.",
    "load_error": "The dashboard could not be loaded.",
    "status_Approved": "Verified",
    "status_Rejected": "Rejected",
    "status_AwaitingEvidence": "Evidence Missing"
  },
  "partner_offers": {
    "title": "Partner Offers",
    "backend_restart_required": "Reactivation is available after restarting the backend server.",
    "redeemable_at": "Redeemable at",
    "redeemable_at_placeholder": "e.g. in store at the checkout",
    "redemption_time": "Redemption hours",
    "redemption_time_placeholder": "e.g. Mon–Fri, 9 am–6 pm",
    "offer": "Offer",
    "not_found": "Offer not found.",
    "location_invalid": "Invalid coordinates entered.",
    "redemption_channel_title": "Redemption method / channel *",
    "type_onsite": "On site",
    "type_digital": "Digital / Online",
    "type_both": "On site & Digital",
    "freq_daily": "Once per day",
    "freq_weekly": "Once per calendar week",
    "freq_monthly": "Once per calendar month",
    "freq_quarterly": "Once per quarter",
    "freq_yearly": "Once per year",
    "freq_every_x_days": "Every {{days}} days",
    "freq_interval": "At set intervals",
    "freq_unlimited": "Unlimited redemptions",
    "valid_from": "From {{date}}",
    "valid_until": "Until {{date}}",
    "always_valid": "Always active",
    "new_offer_btn": "Create New Offer",
    "empty_title": "No offers defined yet",
    "edit": "Edit",
    "edit_title": "Edit Offer",
    "delete": "Delete",
    "confirm_delete": "Do you really want to remove this offer?",
    "modal_title": "Create New Offer",
    "form_title": "Offer Title",
    "form_desc": "Description",
    "location_title": "Offer location *",
    "location_help": "This location is shown as a partner offer on the map.",
    "use_location": "Use current location",
    "form_latitude": "Latitude",
    "form_longitude": "Longitude",
    "location_required": "Please provide a valid offer location.",
    "location_error": "Your current location could not be determined.",
    "map_location": "Visible on the map",
    "form_discount": "Discount in %",
    "use_partner_location": "Use partner location",
    "partner_has_no_coords": "No standard location is set in the partner profile yet.",
    "back_to_offers": "Back to Offers",
    "save": "Save",
    "saving": "Saving …",
    "cancel": "Cancel",
    "validation_required": "Please complete the title, redemption terms, and responsibility confirmation.",
    "form_level": "Character Level",
    "form_category": "Category",
    "form_category_level": "Category Level",
    "form_achievement": "Verified Good Deed",
    "form_type": "Type",
    "type_discount": "Percentage Discount",
    "type_goodie": "Free Goodie",
    "type_service": "Service",
    "type_voucher": "Voucher",
    "requirements_title": "Unlock Requirements",
    "requirements_help": "All configured requirements must be met. Empty fields are not checked.",
    "limits_title": "Redemption Limits",
    "form_frequency": "Frequency",
    "form_interval": "Interval in Days",
    "form_max_user": "Maximum per Person",
    "form_max_total": "Total Inventory",
    "frequency_Unlimited": "Unlimited",
    "frequency_OnceEver": "Once",
    "frequency_OncePerDay": "Once per Day",
    "frequency_OncePerWeek": "Once per Week",
    "frequency_OncePerMonth": "Once per Month",
    "frequency_OncePerYear": "Once per Year",
    "frequency_EveryXDays": "Every X Days",
    "none": "None",
    "req_achievement": "Good deed: {{title}}",
    "load_error": "Offers could not be loaded.",
    "save_error": "The offer could not be saved.",
    "delete_error": "The offer could not be deleted."
  },
  "errors": {
    "tank_notice": " incl. Tank bonus",
    "multitasking_notice": " + Multitasking"
  },
  "error": {
    "title": "System Error",
    "reload": "Reload App"
  },
  "register": {
    "legal_required": "Please confirm that you are at least 18 and accept the terms of use.",
    "legal_accept": "I am at least 18 years old and accept the terms of use.",
    "legal_terms": "Terms of Use",
    "eyebrow": "Become part of the world",
    "field_business_bio": "Business description (optional)",
    "field_location": "Location",
    "required_mark": "Required field",
    "field_business_bio_placeholder": "Briefly describe your business, its offers, and its mission...",
    "title": "Goodvale",
    "subtitle": "Registration",
    "role_adventurer_sub": "Player Account",
    "role_partner": "Partner (Guildhouse)",
    "role_partner_sub": "Marketing",
    "field_username": "Username",
    "field_email": "E-Mail Address",
    "field_password": "Password",
    "field_required": "is required.",
    "classesTitle": "Choose your path",
    "field_business_name": "Business Name",
    "field_category": "Industry / Category",
    "field_tax_id": "VAT / Tax ID",
    "btn_create": "Create Account",
    "btn_apply": "Apply for Account (Admin Review)",
    "btn_loading": "Registering...",
    "review_notice": "To protect the ecosystem, partner accounts cannot be created automatically. After submission, your application will be reviewed manually by the",
    "review_notice_bold": "System Admin",
    "review_notice_end": "after submission.",
    "success_adventurer": "Account created! You can now log in.",
    "success_partner": "Application submitted! The System Admin will activate your account.",
    "success_login_link": "Log in now",
    "already_registered": "Already registered?",
    "login_link": "Log in here",
    "classes_retry": "Retry"
  },
  "login": {
    "title": "Goodvale",
    "emailLabel": "Email Address",
    "passwordLabel": "Password",
    "forgotPasswordLink": "Forgot password?",
    "submit": "Log In",
    "loading": "Logging in…",
    "noAccount": "Don't have an account?",
    "registerLink": "Register now",
    "error": {
      "pendingApproval": "Account is awaiting approval by the System Admin.",
      "generic": "An error occurred. Please check your credentials."
    }
  },
  "forgotPassword": {
    "eyebrow": "Account Recovery",
    "title": "Reset Password",
    "subtitle": "Enter your email address to receive a password reset link.",
    "emailLabel": "Email Address",
    "emailRequired": "Please enter your email address.",
    "submit": "Request Reset Link",
    "loading": "Sending…",
    "backToLogin": "Back to login",
    "successTitle": "Request Sent",
    "successMessage": "If an account exists with this email address, reset instructions have been generated."
  },
  "resetPassword": {
    "eyebrow": "Set New Password",
    "title": "Change Password",
    "subtitle": "Enter your new password to restore access.",
    "newPasswordLabel": "New Password",
    "confirmPasswordLabel": "Confirm Password",
    "missingToken": "Invalid or missing token. Please request a new link.",
    "passwordRequired": "Please enter a new password.",
    "passwordMinLength": "Password must be at least 8 characters long.",
    "passwordMismatch": "Passwords do not match.",
    "submit": "Save Password",
    "loading": "Saving…",
    "successTitle": "Password Updated",
    "successMessage": "Your password has been updated successfully. You can now log in.",
    "loginNow": "Log in now"
  },
  "public_profile": {
    "title": "Public Profile",
    "designations": "Titles",
    "load_error": "Could not load profile.",
    "no_bio_short": "No bio set",
    "heroic_actions_approved": "Approved",
    "heroic_actions_submitted": "Submitted",
    "close": "Close",
    "level": "Lvl {{level}}",
    "member_since": "Member since: {{date}}",
    "community": "In the community",
    "admin_tools": "Management · Authorized admins only",
    "view": "View profile",
    "retry": "Try again",
    "loading": "Loading profile …"
  },
  "location_picker": {
    "title": "Choose a location on the map *",
    "required": "Please choose a location on the map.",
    "locate": "Move map to my location",
    "failed": "Location unavailable. Move the map to your desired location.",
    "center": "Select map center as location",
    "selected": "Selected location",
    "loading": "Finding location …"
  },
  "admin_partners": {
    "subtitle": "Review new partner registrations and manage existing partner businesses.",
    "refresh": "Refresh",
    "username": "Username",
    "email": "Email",
    "category": "Category",
    "vatId": "VAT ID",
    "created": "Registered on",
    "approve": "Approve",
    "reject": "Reject and delete",
    "processing": "Processing request …",
    "reject_confirm": "Reject the partner request from {{name}}? The partner profile and its user account will be permanently deleted.",
    "approved": "{{name}} has been approved as a partner.",
    "rejected": "The registration from {{name}} has been rejected and deleted."
  },
  "admin_nav": {
    "dashboard": "Dashboard & Overview",
    "settings": "System Settings",
    "events": "Events",
    "appeals": "Appeals",
    "profile": "My Profile",
    "logout": "Logout"
  },
  "xp_audit": {
    "status": "Status",
    "pending": "Pending",
    "approved": "Released",
    "rejected": "Rejected",
    "all": "All",
    "empty": "No review cases.",
    "detail": "Review case",
    "threshold": "Threshold",
    "held_awards": "Held rewards",
    "reason": "Reason",
    "reason_required": "Enter a reason of at least three characters.",
    "close": "Close",
    "previous": "Previous",
    "next": "Next",
    "decision_error": "Could not save the decision."
  },
  "admin_tribunal_moderators": {
    "tab_applications": "Open Applications",
    "tab_moderators": "Active Moderators",
    "no_applications": "No open applications available.",
    "search_placeholder": "Filter moderators by name or email...",
    "reviews_count": "{{count}} reviews completed",
    "joined": "Member since {{date}}",
    "motivation_label": "Application Motivation",
    "no_motivation": "No reason provided.",
    "approve_btn": "Approve Application",
    "reject_btn": "Reject Application",
    "revoke_btn": "Remove Status",
    "revoke_confirm_title": "Revoke Moderator Status?",
    "revoke_reason_placeholder": "Reason for revocation (optional)...",
    "approve_prompt": "Reason for approval (optional):",
    "reject_prompt": "Reason for rejection:",
    "approved_success": "Application from {{name}} approved. Moderator status granted.",
    "rejected_success": "Application from {{name}} rejected.",
    "revoked_success": "Moderator status of {{name}} successfully revoked.",
    "view_profile": "Profile"
  },
  "admin_karma": {
    "load_error": "Failed to load users.",
    "pagination": "Page {{page}} of {{total}}",
    "point_count": "{{count}} points",
    "negative_points": "−{{count}} points",
    "positive_points": "+{{count}} points",
    "status_label": "Status",
    "no_reason": "No reason provided",
    "system_actor": "System",
    "approve_penalty": "Approve",
    "reject_penalty": "Reject",
    "subtitle": "System-wide reputation and trust management. Score range ({{minimum}} to {{maximum}}), thresholds, and sanctions.",
    "search_placeholder": "Search user by name or email...",
    "filter_all": "All Accounts",
    "filter_trusty": "Trusty (> 0)",
    "filter_neutral": "Neutral (0)",
    "filter_negative": "Negative (< 0)",
    "filter_banned": "Banned",
    "user_details": "User Details",
    "tier_trusty": "Trusty",
    "tier_honorable": "Reliable",
    "tier_trusted": "Trusted",
    "tier_very_trusted": "Beacon of Hope",
    "tier_exemplary": "Anchor of Trust",
    "tier_neutral": "Neutral",
    "tier_warning": "Partner benefits blocked",
    "tier_restricted": "Temporary suspension (≤ {{suspension}})",
    "tier_released": "Suspension ended; partner lock",
    "tier_banned": "Account Banned",
    "points_label": "Points (1–100)",
    "reason_label": "Reason (Required, min. 5 characters)",
    "reason_placeholder_deduct": "e.g. Code of conduct violation, fake proofs, unsportsmanlike behavior...",
    "reason_placeholder_award": "e.g. Community contribution, rule correction, goodwill...",
    "history_actor": "Performed by",
    "history_delta": "Change",
    "history_score": "New Score",
    "history_reason": "Reason",
    "view_profile": "View Public Profile",
    "close": "Close",
    "rules_range": "Range from {{minimum}} to {{maximum}} points"
  },
  "admin_settings": {
    "title": "System Settings",
    "subtitle": "Global game rules, rates & multipliers — fully configurable without code changes.",
    "search_placeholder": "Filter settings by key, name, or description...",
    "filter_all": "All Settings",
    "filter_custom": "Custom & Other",
    "add_setting_btn": "Add New Setting",
    "add_modal_title": "Create System Setting",
    "add_modal_desc": "Define a new configuration key evaluated across backend and gameplay logic.",
    "key_label": "Setting Key",
    "key_placeholder": "e.g. HeroicActionDailyLimit",
    "value_label": "Value",
    "value_placeholder": "e.g. 1.25",
    "description_label": "Description (Purpose & Impact)",
    "description_placeholder": "e.g. Minimum interval between two good deeds",
    "btn_create": "Create Setting",
    "btn_cancel": "Cancel",
    "btn_save": "Save",
    "btn_save_all": "Save All Changes ({{count}})",
    "btn_revert": "Discard",
    "btn_delete": "Delete",
    "delete_confirm": "Are you sure you want to delete the setting '{{key}}'?",
    "status_saving": "Saving...",
    "status_saved": "Saved",
    "table_header_key": "Setting / Key",
    "table_header_description": "Description & Purpose",
    "table_header_value": "Current Value",
    "table_header_actions": "Actions",
    "empty_search_title": "No matching settings found",
    "empty_search_desc": "No system settings match your current search or filter criteria.",
    "empty_reset_filter": "Reset Filter",
    "toast_save_success": "Setting '{{key}}' successfully saved.",
    "toast_save_all_success": "{{count}} settings successfully updated.",
    "toast_create_success": "New system setting '{{key}}' successfully created.",
    "toast_delete_success": "Setting '{{key}}' successfully removed.",
    "toast_error": "Failed to perform action.",
    "badge_modified": "Modified",
    "total_count": "{{count}} total settings",
    "modified_count": "{{count}} unsaved",
    "quick_stats_total": "Total",
    "quick_stats_modified": "Modified"
  },
  "admin_events": {
    "title": "Events",
    "subtitle": "Control global events to mobilize the community.",
    "create_btn": "New Event",
    "form_title": "Title",
    "form_title_placeholder": "e.g. Forest Week",
    "form_description": "Description",
    "form_description_placeholder": "What does this event do?",
    "form_start": "Start Date",
    "form_end": "End Date",
    "form_category": "Heroic-action category",
    "category_all": "All categories",
    "form_is_recurring": "Recurring weekly",
    "badge_recurring": "Recurring",
    "timeframe": "Period",
    "submit": "Create Event",
    "submitting": "Creating...",
    "update": "Save Changes",
    "updating": "Saving...",
    "cancel": "Cancel",
    "edit": "Edit",
    "delete": "Delete",
    "delete_confirm": "Delete Event?",
    "delete_confirm_text": "Are you sure you want to permanently delete this event?",
    "delete_yes": "Yes, delete",
    "badge_live": "Live",
    "badge_ended": "Ended",
    "badge_upcoming": "Upcoming",
    "ends_at": "Ends:",
    "starts_at": "Starts:",
    "empty": "No events created yet.",
    "load_error": "Could not load events.",
    "create_success": "Event created successfully!",
    "update_success": "Event updated successfully!",
    "create_error": "Failed to create event.",
    "delete_success": "Event deleted successfully.",
    "global_impact_title": "Global Impact"
  },
  "access": {
    "unauthorized_title": "Access Denied",
    "unauthorized_msg": "You do not have permission to view this page.",
    "unauthorized_required_role": "Required role: {{role}}",
    "unauthorized_back_login": "Go to Login",
    "not_logged_in_title": "Not Logged In",
    "not_logged_in_msg": "Please log in to access this area.",
    "role_systemadmin": "System Admin",
    "role_partner": "Partner"
  },
  "nav_cross": {
    "goto_system_admin": "System Admin Console"
  },
  "guild": {
    "public_activity": "Renown & activity",
    "apply_success": "Membership application submitted successfully!",
    "load_more_news": "Load older announcements",
    "load_older_messages": "Load older messages",
    "loading_more": "Loading…",
    "news_load_error": "Could not load more announcements.",
    "apply": "Apply to join",
    "applying": "Submitting …",
    "successor_title": "Appoint a successor",
    "successor_select": "Choose successor:",
    "successor_placeholder": "-- Choose a member --",
    "successor_submit": "Appoint successor & leave",
    "successor_submitting": "Appointing & leaving...",
    "leaving": "Leaving …",
    "detail_subtitle": "Achieve more together.",
    "unknown": "Unknown",
    "insert_emote": "Insert emote",
    "create_news_btn": "New Announcement",
    "news_field_title": "Announcement title",
    "news_category": "Category",
    "news_category_announcement": "Announcement",
    "news_category_event": "Event",
    "news_category_system": "System",
    "news_content": "Content and details",
    "news_pin": "Pin announcement to the top",
    "news_publish": "Publish",
    "news_publish_error": "Could not create the announcement.",
    "news_written_by": "Written by:",
    "news_delete": "Remove announcement",
    "news_delete_success": "Announcement removed.",
    "news_delete_error": "Could not delete the announcement.",
    "news_pinned": "Pinned",
    "no_news": "No news available yet.",
    "view_member_profile": "View Profile",
    "chat_member": "Chat",
    "chat_with_member": "Chat with {{name}}",
    "open_chats": "Open chats",
    "chat_live": "Live channel",
    "chat_for": "Member common table of {{name}}",
    "chat_loading": "Loading common table …",
    "chat_empty": "No conversations at the common table yet",
    "chat_placeholder": "Share a message at the common table …",
    "chat_send": "Send",
    "exclusive_emotes_active": "Common Table Plus active",
    "chat_pinned": "Pinned",
    "chat_pin": "Pin message",
    "chat_unpin": "Unpin message",
    "chat_poll": "Poll",
    "chat_react": "React to message",
    "chat_create_poll": "Create poll",
    "chat_poll_option": "Option {{number}}",
    "chat_add_option": "Add option",
    "chat_remove_option": "Remove last option",
    "chat_post_poll": "Post poll",
    "emote_cat_all": "All",
    "emote_cat_combat": "Combat",
    "emote_cat_magic": "Magic",
    "emote_cat_creatures": "Creatures",
    "emote_cat_mood": "Mood",
    "delete_news_confirm": "Are you sure you want to remove this announcement?",
    "member_badge": "Member",
    "member_profile": "View {{name}}'s profile",
    "promote_admin_btn": "Admin",
    "promote_error": "Promotion failed."
  },
  "notifications": {
    "title": "Notifications",
    "subtitle": "Manage your in-app and push notifications.",
    "mark_all_read": "Mark all as read",
    "mark_as_read": "Mark as read",
    "empty": "No new notifications",
    "empty_state": "No notifications found.",
    "view_all": "View all",
    "btn_read_all": "Read all",
    "btn_enable_push": "Enable Push",
    "btn_disable_push": "Disable Push",
    "push_active": "Push active",
    "push": {
      "requesting": "Requesting permission...",
      "unsupported": "Push notifications are not supported by this browser.",
      "success": "Successfully subscribed!",
      "failed": "Subscription failed.",
      "unsubscribing": "Disabling push notifications...",
      "unsubscribed": "Push notifications successfully disabled.",
      "unsub_failed": "Failed to unsubscribe from push notifications."
    },
    "heroic_action": {
      "approved_title": "Good deed verified",
      "rejected_title": "Good deed rejected",
      "rejected_message": "Your good deed ‘{{title}}’ was not approved. {{reason}}",
      "returned_title": "Good deed returned for revision",
      "returned_message": "Your good deed ‘{{title}}’ was returned. Reason: {{reason}}",
      "review_assigned_message": "The good deed ‘{{title}}’ was independently assigned to you for review.",
      "appeal_pending_title": "New heroic-action appeal",
      "appeal_pending_message": "{{username}} appealed the decision for ‘{{title}}’.",
      "appeal_approved_title": "Appeal accepted",
      "appeal_rejected_title": "Appeal rejected",
      "appeal_rejected_message": "The appeal was rejected. {{reason}}"
    },
    "group_action": {
      "invited_title": "Invitation to a group good deed",
      "announced_title": "New group good deed",
      "cancelled_title": "Group good deed cancelled",
      "cancelled_message": "‘{{title}}’ was cancelled.",
      "approved_title": "Group good deed verified",
      "rejected_title": "Group good deed rejected",
      "rejected_message": "‘{{title}}’ was not approved. {{reason}}",
      "appeal_approved_title": "Group appeal accepted",
      "appeal_approved_message": "The group good deed will receive a new independent review.",
      "appeal_rejected_title": "Group appeal rejected",
      "appeal_rejected_message": "The appeal was rejected. {{reason}}"
    },
    "moderator_approved": {
      "title": "Moderator access approved",
      "message": "Your application was approved. You can now review assigned good deeds."
    },
    "moderator_rejected": {
      "title": "Moderator application rejected",
      "message": "Your application was rejected. Reason: {{reason}}"
    },
    "guild_join_request": {
      "title": "New Join Request",
      "message": "{{username}} submitted a join request for '{{guildName}}'."
    },
    "registration_request": {
      "title": "New Registration Request",
      "message": "New registration request from {{role}} '{{org}}' ({{username}}) pending."
    },
    "direct_chat_new": {
      "title": "New direct message",
      "message": "{{sender}}: {{message}}"
    },
    "event_started": {
      "title": "New Event Started!",
      "message": "The event '{{title}}' has started! Claim exciting bonuses."
    }
  },
  "talents": {
    "branches_count": "3 branches",
    "subtitle": "Choose abilities that suit your good deeds.",
    "modal_subtitle": "Earn one starting point at level 0, then one more every 10 levels, up to 10 in total. Each ability has up to three stages.",
    "level_badge": "Level {{level}}",
    "available_points": "Available Points:",
    "branches": {
      "A": {
        "title": "Path of Efficiency"
      },
      "B": {
        "title": "Path of Progress"
      },
      "C": {
        "title": "Path of Honor"
      }
    },
    "skills": {
      "A_CONCENTRATION": {
        "title": "Concentration",
        "rank1_title": "Concentration",
        "rank2_title": "Meditation",
        "rank3_title": "Zen Focus",
        "rank1_value": "−10% wait",
        "rank2_value": "−20% wait",
        "rank3_value": "−30% wait",
        "rank1": "Stage 1: The wait until your next submission is 10% shorter.",
        "rank2": "Stage 2: The wait until your next submission is 20% shorter.",
        "rank3": "Stage 3: The wait until your next submission is 30% shorter."
      },
      "A_MULTITASKING": {
        "title": "Multitasking",
        "rank1_title": "Multitasking",
        "rank2_title": "Second Brain",
        "rank3_title": "Parallel Mind",
        "rank1_value": "+1 slot",
        "rank2_value": "+2 slots",
        "rank3_value": "+3 slots",
        "rank1": "Stage 1: You can submit 1 more good deed at the same time.",
        "rank2": "Stage 2: You can submit 2 more good deeds at the same time.",
        "rank3": "Stage 3: You can submit 3 more good deeds at the same time."
      },
      "A_HEROIC_ACTION_SPONSOR": {
        "rank1_title": "Patron",
        "rank2_title": "Benefactor",
        "rank3_title": "Grand Philanthropist"
      },
      "B_TREASURE_HUNTER": {
        "title": "Experience Collector",
        "rank1_title": "Experience Collector",
        "rank2_title": "Progress Hunter",
        "rank3_title": "Experience Master"
      },
      "B_BARTERER": {
        "title": "Opportunity Seeker",
        "rank1_title": "Opportunity Seeker",
        "rank2_title": "Value Creator",
        "rank3_title": "Master of Opportunity"
      },
      "B_VERIFIED_PROOF": {
        "title": "Community Spirit",
        "rank1_title": "Community Spirit",
        "rank2_title": "Role Model",
        "rank3_title": "Shining Example"
      },
      "C_RESILIENCE": {
        "title": "Clear Conscience",
        "rank1_title": "Clear Conscience",
        "rank2_title": "Inner Serenity",
        "rank3_title": "Untouchable Honor"
      },
      "C_GROUP_MENTOR": {
        "title": "Party Mentor",
        "rank1_title": "Party Mentor",
        "rank2_title": "Squad Leader",
        "rank3_title": "Paragon Commander"
      },
      "C_GUILD_BENEFACTOR": {
        "title": "Community Builder",
        "rank1_title": "Community Builder",
        "rank2_title": "Anchor of Trust",
        "rank3_title": "Eternal Pillar"
      }
    },
    "stats": {
      "number_locale": "en-US",
      "description": "Description",
      "base": "Base",
      "passive": "Passive",
      "outside_category": "outside {{category}}",
      "in_category": "in {{category}}",
      "category_bonus": "Bonus in your category",
      "points_invested": "{{count}} points invested",
      "heading": "Traits & attributes",
      "breakdown_hint": "(hover over ⓘ for breakdown)",
      "active_count": "{{active}} / {{total}} Active",
      "efficiency_heading": "Efficiency & slots",
      "experience_heading": "Experience & bonuses",
      "info_aria": "Info: {{label}}",
      "base_bonus": "0% bonus",
      "cooldown": {
        "talent": "-{{percent}}% (max -30%)"
      },
      "slots": {
        "label": "Slots",
        "count_one": "{{count}} slot",
        "count_other": "{{count}} slots",
        "description": "This is how many individual good deeds and group actions you can have open at once.",
        "talent_one": "+{{count}} slot (max +3)",
        "talent_other": "+{{count}} slots (max +3)",
        "class_effect": "+{{count}} slot"
      },
      "xp_bonus": {
        "talent": "+{{percent}}% (max +15%)"
      },
      "cat_xp_bonus": {
        "talent": "+{{total}}% (general +{{general}}%, category +{{category}}%; max +30%)"
      },
      "gildex": {
        "effective": "{{percent}}% effective",
        "base_value": "{{percent}}% base",
        "talent": "+{{percent}}% relative (max +30%)",
        "class_effect": "{{percent}} relative"
      },
      "karma_rec": {
        "up_to": "up to +{{value}}",
        "base": "0 extra recovery"
      },
      "party_ep": {
        "base": "0% group bonus",
        "talent": "+{{percent}}% (max +15% per member)"
      }
    },
    "ui": {
      "rank2_fallback": "Endurance",
      "rank3_fallback": "Composure",
      "rank_points_max": "{{points}} pts (Max)",
      "next_point_xp": "Next point: Lv. {{level}}",
      "back_to_overview": "Back to overview",
      "pts_unit": "pts",
      "points_ready_tip": "Ready to invest",
      "no_points_tip": "Next point at level-up",
      "spent_points": "Invested",
      "active_buffs_active": "Active boosts",
      "current_level_label": "Level",
      "max_level_reached": "Maximum level reached",
      "three_pillars_sub": "Efficiency • Progress • Honor",
      "available_short": "available",
      "tier": "Path stage {{tier}}",
      "upgrading": "Upgrading...",
      "close": "Close",
      "branch_badge": "Branch {{branch}}",
      "branch": "Branch",
      "select_skill_hint": "Click any skill circle to view details and upgrade options",
      "locked_stage": "Locked",
      "active_rank": "Active",
      "all_branches": "All Paths"
    },
    "path_names": {
      "A": "Efficiency",
      "B": "Progress",
      "C": "Honor"
    },
    "tree": {
      "learned": "Learned",
      "available": "Available",
      "locked": "Locked",
      "requires_skill": "First raise {{name}} to stage {{rank}}"
    }
  },
  "categories": {
    "SOCIAL_COMMUNITY": "Social & Community"
  },
  "classes": {
    "roles": {
      "GUARDIAN": "Social & Community"
    },
    "lines": {
      "SCOUT": "Help people get moving.",
      "MEDIC": "Everyday care.",
      "SOCIAL": "Bring people together.",
      "TANK": "Help when hands are needed.",
      "ENVIRONMENT": "Protect nature and care for shared spaces.",
      "TECH": "Share knowledge and explain technology.",
      "CRAFTER": "Repair instead of discarding.",
      "NUTRITION": "Help through food.",
      "LOGISTICS": "Organize help well.",
      "GUARDIAN": "Support others safely."
    },
    "descriptions": {
      "SCOUT": "Accompany people on journeys, help with transport, or make outdoor activities easier.",
      "MEDIC": "Support health and wellbeing activities and help people with your time and attention.",
      "SOCIAL": "Help with events and shared activities that connect people.",
      "TANK": "Assist with physical tasks, movement, and sports. Your effort makes practical help possible.",
      "ENVIRONMENT": "Collect litter, care for green spaces, or help with nature and environmental projects.",
      "TECH": "Help someone learn, explain digital tools, or solve everyday technical problems.",
      "CRAFTER": "Fix useful items, build something others need, or share practical skills.",
      "NUTRITION": "Assist with shopping, preparing meals, or distributing food.",
      "LOGISTICS": "Plan routes, transport supplies, and make sure help reaches the people who need it.",
      "GUARDIAN": "Help people get around safely and take on reliable tasks for the community."
    }
  },
  "perks": {
    "CLASS_V2_SCOUT_ABILITY": "You wait 10% less time between submissions.",
    "CLASS_V2_TANK_ABILITY": "You can submit one additional good deed at the same time.",
    "CLASS_V2_CRAFTER_ABILITY": "You can revise one rejected individual action and submit it for review once more.",
    "CLASS_V2_LOGISTICS_ABILITY": "Once per calendar week, you can skip the wait until your next submission. You still need a free slot.",
    "titles": {
      "CLASS_V2_SCOUT_CATEGORY": "Bonus in your category",
      "CLASS_V2_SCOUT_ABILITY": "Shorter wait",
      "CLASS_V2_TANK_CATEGORY": "Bonus in your category",
      "CLASS_V2_TANK_ABILITY": "More simultaneous submissions",
      "CLASS_V2_GUARDIAN_CATEGORY": "Bonus in your category",
      "CLASS_V2_CRAFTER_CATEGORY": "Bonus in your category",
      "CLASS_V2_CRAFTER_ABILITY": "Second review chance",
      "CLASS_V2_SOCIAL_CATEGORY": "Bonus in your category",
      "CLASS_V2_SOCIAL_ABILITY": "Group bonus",
      "CLASS_V2_LOGISTICS_CATEGORY": "Bonus in your category",
      "CLASS_V2_LOGISTICS_ABILITY": "Skip the wait",
      "CLASS_V2_NUTRITION_CATEGORY": "Bonus in your category",
      "CLASS_V2_TECH_CATEGORY": "Bonus in your category",
      "CLASS_V2_ENVIRONMENT_CATEGORY": "Bonus in your category",
      "CLASS_V2_MEDIC_CATEGORY": "Bonus in your category"
    }
  },
  "api": {
    "guild_unlock": {
      "requires_stammtisch": "Unlock the Common Table first.",
      "requires_group_actions": "Unlock Group Good Deeds first."
    },
    "messages": {
      "settings_anti_cheat_invalid": "Invalid anti-cheat threshold or time window.",
      "partner_redemption_details_length": "The redemption place and time must each be at most 250 characters long.",
      "guild_application_status_invalid": "Invalid application status.",
      "guild_application_already_decided": "This application has already been reviewed.",
      "auth_direct_message_setting_invalid": "Invalid direct message setting.",
      "direct_chat_recipient_privacy": "This person does not accept direct messages from you.",
      "guild_statistics_period_invalid": "Invalid time period.",
      "heroic_draft_too_long": "The draft is too long.",
      "heroic_category_invalid": "Choose a specific category for the good deed.",
      "heroic_assessment_invalid": "Invalid assessment.",
      "heroic_draft_not_found": "Draft not found.",
      "heroic_draft_not_open": "This good deed is no longer a draft.",
      "heroic_draft_load_failed": "The draft could not be loaded.",
      "heroic_draft_delete_only": "Only drafts can be deleted.",
      "heroic_already_submitted": "This good deed has already been submitted.",
      "heroic_resubmit_status_invalid": "Only withdrawn or returned good deeds can be resubmitted.",
      "heroic_delete_admin_only": "Only active system administrators can delete submissions.",
      "heroic_submission_not_found": "Submission not found.",
      "heroic_reward_disposition_required": "Choose whether to keep or reverse rewards.",
      "heroic_evidence_cleanup_failed": "The submission was deleted, but at least one encrypted evidence file could not be removed. Its path was recorded for cleanup in the admin audit.",
      "heroic_recalculate_approved_only": "Only approved submissions can be recalculated.",
      "heroic_historical_bonus_missing": "Stored bonus data is missing for this older submission.",
      "heroic_group_bonus_missing": "The stored group bonus is missing.",
      "heroic_group_bonuses_incomplete": "The stored group bonuses are incomplete.",
      "heroic_category_progress_missing": "Category progress is missing.",
      "heroic_list_admin_only": "Only system administrators can view all submissions.",
      "heroic_return_reason_required": "A reason of at most 2,000 characters is required.",
      "heroic_own_group_review_forbidden": "You cannot review your own group actions or actions you participated in.",
      "heroic_rewarded_return_forbidden": "A rewarded submission cannot be returned.",
      "heroic_reason_too_long": "The reason must be at most 2,000 characters long.",
      "heroic_admin_not_found": "Administrator not found.",
      "heroic_restart_admin_only": "Only active system administrators can restart a review round.",
      "heroic_review_round_stale": "The review round is out of date or the submission is no longer under review.",
      "heroic_own_action_restart_forbidden": "You cannot restart the review of your own good deeds.",
      "heroic_own_group_restart_forbidden": "You cannot restart the review of your own group actions or actions you participated in.",
      "heroic_review_round_no_votes": "This review round has no votes yet.",
      "heroic_review_round_changed": "More votes have been cast since you loaded the submission. Reload the page.",
      "heroic_rewarded_restart_forbidden": "The review of a rewarded submission cannot be restarted.",
      "heroic_already_reviewed_round": "You already reviewed this submission in the current round.",
      "heroic_category_select_required": "Choose a valid category.",
      "heroic_category_locked": "The category was set by the first review and cannot be changed in this round.",
      "heroic_withdraw_before_evidence_removal": "Withdraw the submission before removing existing evidence.",
      "passwort_und_neues_passwort_erforderlich": "Please complete all password fields.",
      "group_action_title_length": "The title must be between 1 and 150 characters.",
      "group_action_description_length": "The description must be between 1 and 2,000 characters.",
      "group_action_declarations_required": "Confirm all organizer declarations.",
      "group_action_commercial_work": "This action appears to involve commercial work or replacing paid work.",
      "group_action_category_invalid": "Choose a valid category for the group action.",
      "group_action_difficulty_invalid": "Choose a valid estimate for time and effort.",
      "group_action_complexity_invalid": "Choose a valid estimate for planning and coordination.",
      "group_action_scheduled_future": "The scheduled time must be in the future.",
      "group_action_deadline_future": "The sign-up deadline must be in the future.",
      "group_action_deadline_after_schedule": "The sign-up deadline cannot be after the scheduled time.",
      "group_action_participants_range": "The participant limit must be between 2 and 500.",
      "event_category_invalid": "Choose a valid event category.",
      "passwort_erfolgreich_geaendert": "Password changed successfully.",
      "aktuelles_passwort_falsch": "The current password is incorrect.",
      "passwort_zu_kurz": "Password must be at least 8 characters long.",
      "location_required": "Please choose a location on the map.",
      "administrator_nicht_gefunden_30": "Administrator not found.",
      "aktueller_benutzer_nicht_gefun_104": "Current user not found.",
      "anfrage_konnte_nicht_gestellt__28": "The request could not be submitted (for example, the user may be blocked).",
      "angebot_erfolgreich_gel_scht_57": "Offer deactivated successfully.",
      "angebot_nicht_gefunden_oder_ke_56": "Offer not found or permission denied.",
      "aushang_erfolgreich_entfernt_34": "Notice removed successfully.",
      "beitrittsanfrage_erfolgreich_b_29": "Membership application submitted successfully.",
      "benutzer_nicht_gefunden_1": "User not found.",
      "benutzer_nicht_gefunden_37": "User not found.",
      "benutzername_e_mail_passwort_u_4": "Username, email, password, and company name are required.",
      "benutzerprofil_nicht_gefunden_99": "User profile not found.",
      "beschreibung_darf_max_300_zeic_24": "The description must not exceed 300 characters.",
      "das_bild_darf_maximal_5_mb_gro_94": "The image must not exceed 5 MB.",
      "das_enddatum_muss_nach_dem_sta_17": "The end date must be after the start date.",
      "das_enddatum_muss_nach_dem_sta_20": "The end date must be after the start date.",
      "das_icon_darf_maximal_2mb_g": "The icon must not exceed 2 MB.",
      "die_datei_ist_kein_g_ltiges_bi_76": "The file is not a valid image.",
      "die_datei_ist_kein_g_ltiges_bi_97": "The file is not a valid image.",
      "dieser_benutzer_erfordert_kein_2": "This user does not require approval.",
      "du_kannst_nur_f_r_dein_eigenes_27": "You can only submit a membership application for your own profile.",
      "ein_benutzer_mit_dieser_e_mail_5": "A user with this email address or username already exists.",
      "ein_titel_ist_erforderlich_16": "A title is required.",
      "ein_titel_ist_erforderlich_19": "A title is required.",
      "einstellung_erfolgreich_geloescht": "Setting deleted successfully.",
      "einstellung_erfolgreich_gespeichert": "Setting saved successfully.",
      "einstellung_nicht_gefunden": "Setting not found.",
      "einstellungsschluessel_darf_nicht_leer_sein": "The setting key must not be empty.",
      "event_erfolgreich_gel_scht_22": "Event deleted successfully.",
      "event_nicht_gefunden_15": "Event not found.",
      "event_nicht_gefunden_18": "Event not found.",
      "event_nicht_gefunden_21": "Event not found.",
      "ffentliches_benutzerprofil_nic_101": "Public user profile not found.",
      "icon_nicht_gefunden": "Icon not found.",
      "kategorie_erfolgreich_archivie_10": "Category archived successfully.",
      "kategorie_erfolgreich_wiederhe_11": "Category restored successfully.",
      "keine_bilddatei_bermittelt_72": "No image file was provided.",
      "keine_bilddatei_bermittelt_93": "No image file was provided.",
      "keine_datei_ausgew_hlt_44": "No file was selected.",
      "konto_wartet_auf_freischaltung_14": "The account is awaiting approval by a system administrator.",
      "nur_jpg_png_und_webp_formate_s_95": "Only JPG, PNG, and WEBP images are allowed.",
      "nur_png_dateien_erlaubt": "Only PNG files are allowed for icons.",
      "partnerprofil_erfolgreich_aktu_60": "Partner profile updated successfully.",
      "partnerprofil_nicht_gefunden_61": "Partner profile not found.",
      "profil_konnte_nicht_aktualisie_100": "The profile could not be updated.",
      "profil_konnte_nicht_aktualisie_62": "The profile could not be updated.",
      "profilbeschreibung_erfolgreich_91": "Profile description updated successfully.",
      "profilbild_erfolgreich_aktualisiert": "Profile picture updated successfully.",
      "profilbild_nicht_gefunden_103": "Profile picture not found.",
      "push_abonnement_erfolgreich_re_48": "Push subscription registered successfully.",
      "qr_token_darf_nicht_leer_sein_50": "The QR code must not be empty.",
      "sowohl_breitengrad_als_auch_l__41": "Both latitude and longitude must be provided.",
      "suchbegriff_darf_nicht_leer_se_3": "The search term must not be empty.",
      "suchbegriff_darf_nicht_leer_se_98": "The search term must not be empty.",
      "titel_ist_erforderlich_54": "A title is required.",
      "titel_und_inhalt_sind_erforder_87": "A title and content are required.",
      "ung_ltige_benutzer_identifikat_49": "Invalid user identity.",
      "ung_ltige_benutzer_identifikat_51": "Invalid user identity.",
      "ung_ltige_benutzer_identifikat_52": "Invalid user identity.",
      "ung_ltige_benutzer_identifikat_53": "Invalid user identity.",
      "ung_ltige_benutzer_identifikat_55": "Invalid user identity.",
      "ung_ltige_benutzer_identifikat_58": "Invalid user identity.",
      "ung_ltige_benutzer_identifikat_59": "Invalid user identity.",
      "ung_ltige_benutzer_identifikat_88": "Invalid user identity.",
      "ung_ltige_benutzer_identifikat_89": "Invalid user identity.",
      "ung_ltige_benutzer_identifikat_90": "Invalid user identity.",
      "ung_ltige_benutzer_identifikat_92": "Invalid user identity.",
      "ung_ltige_bilddatei_75": "Invalid image file.",
      "ung_ltige_bilddatei_96": "Invalid image file.",
      "ung_ltige_koordinaten_f_r_den__26": "Invalid location coordinates.",
      "ung_ltige_push_subscription_da_47": "Invalid push subscription data.",
      "ung_ltiger_breitengrad_90_bis__42": "Invalid latitude (-90 to 90).",
      "ung_ltiger_dateiname_102": "Invalid file name.",
      "ung_ltiger_dateiname_85": "Invalid file name.",
      "ung_ltiger_l_ngengrad_180_bis__43": "Invalid longitude (-180 to 180).",
      "ung_ltiger_status_erlaubt_appr_30": "Invalid status. Allowed values: Approved, Denied, Blocked.",
      "ungueltiger_schluessel": "Invalid key.",
      "heroic_review_thresholds_invalid": "The review thresholds are invalid.",
      "heroic_withdraw_own_only": "You can withdraw only your own good deeds.",
      "heroic_withdraw_pending_only": "You can withdraw only good deeds that are under review.",
      "heroic_parallel_limit": "You can have at most {{maxParallel}} good deeds in progress.",
      "heroic_appeal_deadline_passed": "The {{days}} day appeal period has ended.",
      "talent_prerequisite": "Invest at least two points in {{talent}} first (level 2/3).",
      "class_perk_category_not_found": "The category was not found.",
      "admin_partner_created": "Partner business {{name}} created successfully.",
      "guild_application_status_changed": "Application status changed to {{status}}.",
      "admin_partner_deleted": "Partner deleted successfully.",
      "admin_icon_uploaded": "Icon uploaded successfully.",
      "admin_reason_required": "Provide a reason of 5–1,000 characters.",
      "admin_delta_nonzero": "The adjustment cannot be zero.",
      "heroic_evidence_upload_missing": "Choose an evidence file to upload.",
      "system_admin_transfer_required": "Another administrator must transfer or remove system admin accounts.",
      "heroic_player_not_found": "The player was not found.",
      "heroic_title_length": "The title must be 1–150 characters long.",
      "heroic_description_length": "The description must be 1–2,000 characters long.",
      "heroic_difficulty_invalid": "Choose a valid time and effort estimate.",
      "heroic_complexity_invalid": "Choose a valid planning and coordination estimate.",
      "heroic_evidence_type_invalid": "Choose a valid evidence type.",
      "heroic_future_date": "The good deed date cannot be in the future.",
      "heroic_evidence_upload_required": "Upload an evidence file for this evidence type.",
      "heroic_event_inactive": "This system event is not active.",
      "heroic_event_limit_reached": "This system event has reached its submission limit.",
      "heroic_load_failed": "The good deed could not be loaded.",
      "heroic_own_action_not_found": "Your good deed was not found.",
      "heroic_action_not_found": "The good deed was not found.",
      "heroic_resubmit_requires_withdrawal": "Only withdrawn good deeds can be submitted again.",
      "heroic_evidence_required": "This evidence type requires an existing or new file.",
      "heroic_progress_invalid": "Enter valid progress values.",
      "heroic_rejection_reason_required": "Provide a reason when rejecting a good deed.",
      "heroic_rejection_reason_length": "The rejection reason must be at most 2,000 characters long.",
      "heroic_review_closed": "This good deed is no longer under review.",
      "heroic_cannot_review_own": "You cannot review your own good deeds.",
      "heroic_reviewer_not_found": "The reviewer was not found.",
      "heroic_review_not_assigned": "This good deed is not assigned to you for review.",
      "heroic_review_own_participation": "You cannot review your own good deed or one you participated in.",
      "heroic_review_other_players_first": "Review other players' good deeds before reviewing this player again.",
      "heroic_review_difficulty_required": "Choose a valid estimate for time and effort.",
      "heroic_review_complexity_required": "Choose a valid estimate for planning and coordination.",
      "heroic_group_two_participants_required": "A group action needs at least two confirmed participants.",
      "heroic_moderator_application_pending": "Your moderator application is already under review.",
      "heroic_moderator_motivation_length": "The motivation must be 20–2,000 characters long.",
      "heroic_moderator_decision_admin_only": "Only system administrators can decide moderator applications.",
      "heroic_moderator_application_missing": "No pending moderator application was found.",
      "heroic_moderator_manage_admin_only": "Only system administrators can manage moderator permissions.",
      "heroic_appeal_reason_length": "Explain the appeal in 20–2,000 characters.",
      "heroic_appeal_participants_only": "Only affected participants can appeal.",
      "heroic_appeal_rejected_only": "You can appeal only a rejected good deed.",
      "heroic_appeal_evidence_missing": "The appeal cannot be reviewed without the original evidence.",
      "heroic_appeal_limit_reached": "No further appeal is possible for this good deed.",
      "heroic_appeal_admin_only": "Only system administrators can decide appeals.",
      "heroic_appeal_decision_reason_required": "Provide a brief reason for the appeal decision.",
      "heroic_appeal_not_found": "The appeal was not found.",
      "heroic_appeal_already_decided": "This appeal has already been decided.",
      "heroic_action_state_changed": "The good deed status has already changed. Reload and try again.",
      "heroic_decision_own_action": "You cannot decide your own good deeds or their appeals.",
      "heroic_evidence_privacy_required": "Confirm the evidence privacy rules before uploading.",
      "heroic_evidence_upload_closed": "You cannot add evidence after the final decision.",
      "heroic_evidence_size": "The evidence file must be between 1 byte and 10 MB.",
      "heroic_evidence_format": "This file type or signature is not allowed.",
      "heroic_evidence_reused": "This evidence file was already used for another submission.",
      "heroic_evidence_not_found": "The evidence was not found.",
      "heroic_evidence_file_missing": "The evidence file is missing from the server.",
      "heroic_evidence_delete_closed": "Evidence can be deleted only before review begins.",
      "heroic_evidence_forbidden": "You do not have access to this evidence.",
      "heroic_evidence_storage_invalid": "The evidence storage path is invalid.",
      "partner_business_not_found": "No partner business was found for this account.",
      "partner_offer_title_length": "The offer title must be 1–150 characters long.",
      "partner_offer_description_length": "The offer description must be at most 2,000 characters long.",
      "partner_offer_type_invalid": "Choose a valid offer type.",
      "partner_offer_discount_range": "The discount must be between 0 and 100 percent.",
      "partner_offer_redemption_type_invalid": "Choose on site, digital, or both as the redemption method.",
      "partner_offer_location_required": "Choose a location for an on site offer.",
      "partner_offer_coordinates_invalid": "Choose valid location coordinates.",
      "partner_offer_code_length": "The voucher code must be at most 100 characters long.",
      "partner_offer_url_length": "The redemption URL must be at most 500 characters long.",
      "partner_offer_instructions_length": "The redemption instructions must be at most 1,000 characters long.",
      "partner_offer_category_invalid": "Choose a valid offer category.",
      "partner_offer_progress_category_invalid": "Choose a valid progress category.",
      "partner_offer_progress_negative": "Progress requirements cannot be negative.",
      "partner_offer_progress_category_required": "Choose a category for the category progress requirement.",
      "partner_offer_good_deed_requirement_missing": "The selected good deed requirement does not exist.",
      "partner_offer_frequency_invalid": "Choose a valid redemption frequency.",
      "partner_offer_day_interval_invalid": "Enter a positive number of days for the interval.",
      "partner_offer_limit_invalid": "Redemption limits must be positive.",
      "partner_company_name_length": "The company name must be 1–150 characters long.",
      "partner_category_invalid": "Choose a valid partner category.",
      "direct_chat_self": "You cannot send messages to yourself.",
      "direct_chat_message_length": "The message must be at most 1,000 characters long.",
      "direct_chat_recipient_not_found": "The recipient was not found.",
      "direct_chat_sender_not_found": "The sender was not found.",
      "direct_chat_account_suspended": "Your account is suspended and cannot send messages.",
      "direct_chat_wait_one_second": "Wait one second before sending another message.",
      "direct_chat_rate_limit": "You have reached the limit of 15 direct messages per minute. Please wait.",
      "direct_chat_consecutive_limit": "You have sent five messages in a row. Wait for a reply.",
      "settings_nonnegative_integer_required": "This setting must be a nonnegative whole number.",
      "settings_positive_value_required": "This setting must be greater than zero.",
      "settings_review_threshold_order": "Review thresholds must increase from one review to two reviews to admin review.",
      "settings_evidence_retention_invalid": "Evidence must be kept at least seven days longer than the appeal period.",
      "class_perk_key_title_required": "Enter a perk key and title.",
      "class_perk_category_invalid": "Choose a valid target category.",
      "class_perk_effect_required": "Choose an effect type.",
      "class_perk_effect_invalid": "Choose a valid effect type.",
      "class_perk_value_range": "The effect value must be between 0 and 3.",
      "password_reset_email_unavailable": "Password reset email is currently unavailable.",
      "guild_chat_empty": "Enter a message.",
      "guild_chat_message_not_found": "The chat message was not found.",
      "guild_user_not_found": "The user was not found.",
      "guild_reaction_invalid": "Choose a valid reaction.",
      "guild_poll_invalid": "Enter a question and 2–5 different poll options.",
      "guild_poll_option_invalid": "Choose a valid poll option.",
      "guild_emblem_too_large": "The emblem image must be 5 MB or smaller.",
      "guild_emblem_invalid_format": "Use a PNG, JPG, WEBP, or SVG image.",
      "guild_latitude_required": "Choose a location on the map.",
      "guild_longitude_required": "Choose a location on the map.",
      "guild_requester_not_found": "Your account could not be found. Please sign in again.",
      "guild_leadership_transfer_invalid": "This leadership transfer is not allowed.",
      "guild_cannot_promote_system_admin": "The role of a system administrator cannot be changed.",
      "guild_account_unavailable": "This account is inactive or suspended.",
      "group_action_registration_closed": "Registration for this group action is closed.",
      "group_action_deadline_passed": "The registration deadline has passed.",
      "group_action_full": "This group action is full.",
      "group_action_withdraw_closed": "You cannot withdraw after the action has been submitted.",
      "group_action_registration_missing": "You have no active registration for this action.",
      "group_action_confirmation_closed": "Participation can no longer be confirmed.",
      "group_action_confirmation_too_early": "Confirm participation after the group action starts.",
      "group_action_not_registered": "You are not registered for this group action.",
      "group_action_already_submitted": "This group action has already been submitted or closed.",
      "group_action_submit_too_early": "Submit the action after its scheduled start.",
      "group_action_two_confirmations_required": "At least two members must confirm participation.",
      "group_action_future_date": "The date cannot be in the future.",
      "group_action_date_before_schedule": "The completion date is before the scheduled group action.",
      "group_action_external_evidence_forbidden": "External evidence links are not allowed. Upload an encrypted file.",
      "group_action_evidence_required": "An encrypted evidence file is required.",
      "group_action_cancel_closed": "Only open group actions can be cancelled.",
      "group_action_delete_closed": "Only cancelled group actions can be deleted.",
      "group_action_not_found": "The group action was not found.",
      "group_action_parallel_limit": "You have reached your limit of parallel good deeds.",
      "guild_founder_not_found": "Your account could not be found. Please sign in again.",
      "karma_penalty_invalid": "Enter 1–100 points and a reason of 5–1000 characters.",
      "account_not_deleted": "Only previously deleted accounts can be permanently removed.",
      "account_suspended": "This account has been suspended.",
      "account_suspended_reason": "This account has been suspended. Reason: {{reason}}",
      "account_suspended_admin": "This account was suspended by an administrator. No specific reason is recorded.",
      "das_banner_darf_maximal_8_mb_gross_sein": "The banner must not exceed 8 MB.",
      "banner_erfolgreich_aktualisiert": "Banner updated successfully.",
      "class_skip_unavailable": "Good Contacts is unavailable this week.",
      "class_skip_merchant_only": "Only merchants can use Good Contacts.",
      "class_elixir_unavailable": "Experience elixir is unavailable this week.",
      "class_repair_only": "Only blacksmiths can repair good deeds.",
      "class_repair_unavailable": "Only a rejected action that has not been repaired can be repaired.",
      "class_repair_individual": "Repair is only available for your own individual actions.",
      "class_repair_appeal": "Repair is unavailable while an appeal is pending.",
      "class_repair_revision": "Revise the description (1–2000 characters) or upload new evidence.",
      "class_repair_slot": "Repair requires an available submission slot.",
      "class_repair_evidence": "The original evidence has expired. Please upload new evidence.",
      "email_bereits_registriert": "This email address is already registered.",
      "ungueltige_email_oder_passwort": "Invalid email/username or password.",
      "benutzername_bereits_vergeben": "This username is already taken.",
      "pflichtfelder_ausfuellen": "Username, email, and password are required.",
      "ungueltige_partnerkategorie": "The selected partner category is invalid.",
      "passwort_zuruecksetzen_angefordert": "If an account exists with this email address, reset instructions have been generated.",
      "passwort_erfolgreich_zurueckgesetzt": "Your password has been updated successfully.",
      "reset_token_ungueltig_oder_abgelaufen": "Invalid or expired reset token.",
      "video_duration_invalid": "The MP4 video must have a readable duration of no more than 10 seconds.",
      "email_confirmation_required": "Please confirm your email address first.",
      "email_confirmation_invalid": "This confirmation link is invalid, expired, or already used. Request a new link if needed.",
      "email_delivery_failed": "The confirmation email could not be sent. Please request a new confirmation link in one minute.",
      "group_xp_allocation_invalid": "Allocate exactly 100% using whole percentages. Each confirmed person may receive 0–50%; at least two people need a positive share.",
      "group_action_account_inactive": "The account is inactive or suspended."
    },
    "status": {
      "400": "Please check your input.",
      "401": "Please sign in again.",
      "403": "You do not have permission for this action.",
      "404": "The requested content was not found.",
      "409": "This action is not possible in the current state. Please reload the data.",
      "413": "The file is too large.",
      "415": "This file format is not supported.",
      "422": "Please check your input.",
      "500": "A server error occurred. Please try again later.",
      "502": "The server is temporarily unreachable.",
      "503": "This service is not configured or currently unavailable.",
      "generic": "The request could not be processed.",
      "network": "Cannot connect to the server. Please check your internet connection.",
      "success": "The action was completed successfully."
    }
  },
  "errorPage": {
    "notice": "Notice",
    "retry": "Try again",
    "home": "Go to overview",
    "back": "Go back",
    "login": "Sign in",
    "notFound": {
      "title": "This path leads nowhere.",
      "description": "The page or requested content could not be found. Return to the overview or try again."
    },
    "forbidden": {
      "title": "This area is locked.",
      "description": "You do not have permission to access this content."
    },
    "session": {
      "title": "Your journey is waiting.",
      "description": "Please sign in again to continue."
    },
    "unavailable": {
      "title": "A brief pause on your journey.",
      "description": "We could not load this content right now. Please try again in a moment."
    }
  },
  "faq_page": {
    "title": "Frequently Asked Questions"
  },
  "evidence_picker": {
    "label": "Choose evidence type",
    "Video": "Short video",
    "SelfReport": "No visual evidence",
    "Photo": "Photo",
    "PhotoGps": "Photo with location",
    "Document": "Document",
    "recommended": "Recommended",
    "preview": "Preview: {{name}}"
  },
  "review_evidence": {
    "title": "Review evidence",
    "count_one": "{{count}} file",
    "count_other": "{{count}} files",
    "before": "Before",
    "after": "After",
    "activity": "Activity",
    "photos": "Photos",
    "documents": "Documents",
    "other": "Other evidence",
    "assignment_hint": "Before / After / Activity are assigned from file names. These labels and “Direct recording” do not prove authenticity.",
    "failed": "Could not load the preview.",
    "retry": "Try again",
    "open": "Open full size",
    "preview": "Evidence: {{name}}",
    "loading": "Loading preview …",
    "document": "Document for review",
    "load_document": "Load document",
    "video": "Video",
    "photo": "Photo",
    "file": "File",
    "self_report": "Evidence type: No visual evidence. No file required.",
    "empty": "No evidence file available.",
    "play": "Load & play video",
    "upload_date": "Upload date",
    "expiry_date": "Expiry date",
    "deletion_prefix": "Deletion"
  },
  "admin_directory": {
    "delete_user": "Delete user",
    "permanent_delete_user": "Delete permanently",
    "permanent_delete_confirm": "Completely remove the deleted account “{{name}}” and its related user data from the database? This cannot be undone.",
    "delete_confirm": "Permanently delete user “{{name}}”? Personal data will be removed and the account permanently disabled. This cannot be undone.",
    "users": "All users",
    "search": "Search name or email",
    "loading": "Loading …",
    "members": "Members",
    "details": "Details",
    "edit": "Edit details",
    "level": "Level",
    "active": "Active",
    "banned": "Suspended",
    "manage": "Manage user",
    "empty": "No entries",
    "previous": "Previous",
    "next": "Next",
    "close": "Close",
    "profile": "Public profile",
    "review": "Review good deeds",
    "suspension": "Account suspension",
    "reason": "Reason (recorded in audit log)",
    "ban": "Suspend account",
    "unban": "Lift suspension",
    "reason_required": "Provide a reason of 5–1000 characters.",
    "search_users": "Search name or email …",
    "renown": "Renown",
    "heroic_actions": "Good Deeds",
    "unlocks": "Unlocks & Purchases",
    "leader": "Leader",
    "location": "Location",
    "overview_tab": "Overview & Metrics",
    "unlocks_tab": "Shop & Unlocks",
    "ledger_tab": "Transaction Ledger",
    "members_tab": "Members",
    "news_tab": "Announcements & News",
    "all_time_renown": "Total Renown",
    "weekly_activity": "Weekly Activity",
    "yearly_activity": "Yearly Activity",
    "group_actions": "Group Good Deeds",
    "registered": "Registered: {{date}}",
    "tab_overview": "Overview & Profile",
    "tab_suspension": "Account Suspension & Status",
    "tab_submissions": "Submissions",
    "tab_partner": "Partner Settings & Offers",
    "level_num": "Level {{level}}",
    "confirmed": "confirmed",
    "business_card_preview": "Business Card Preview:",
    "current_status": "Current Account Status:",
    "suspension_placeholder": "State reason for suspension or reactivation (will be saved in audit log)...",
    "sysadmin_cannot_be_banned": "System administrators cannot be banned.",
    "rejection_reason": "Rejection reason:",
    "submitted_at": "Submitted on: {{date}}",
    "page_of": "Page {{current}} of {{total}}",
    "sum_of_members": "Sum of all {{count}} members",
    "weekly_since_monday": "Weekly (since Monday)",
    "thereof_group_actions": "thereof {{count}} group actions",
    "this_calendar_year": "This calendar year",
    "total_history": "Total History",
    "next_renown_stage": "Next Renown Stage: {{name}}",
    "renown_progress": "{{current}} / {{max}} Renown",
    "view_profile": "View profile",
    "author": "Author: {{name}}",
    "pinned": "• Pinned",
    "no_announcements": "No announcements available.",
    "heroic_actions_count": "{{count}} good deeds",
    "no_description": "No description provided.",
    "purchases_count": "{{count}} purchases"
  },
  "classesAndRanks": {
    "eyebrow": "Your path through Goodvale"
  },
  "ranksGuide": {
    "eyebrow": "Your progress in Goodvale",
    "start": "Start",
    "dynamic": "Current system values",
    "defaults": "Default values",
    "loadError": "The live configuration could not be loaded. Default values are shown."
  },
  "landing": {
    "roles_intro": "Good deeds, review, community, and recognition work together here.",
    "role_actions": [
      "Do good",
      "Review deeds",
      "Act together",
      "Reward impact"
    ],
    "karma_kicker": "Trust and consequences",
    "start": "Join Now",
    "more": "How it works",
    "classesTitle": "Choose your path",
    "guildFeature": {
      "kicker": "Do more together"
    },
    "partnerFeature": {
      "kicker": "Reward local impact",
      "title": "Partners give good deeds real-world value.",
      "intro": "Businesses and organizations can support people who make a difference. As a partner, you present your offer on Goodvale and set the verified achievements needed to access it. Recognition becomes a tangible benefit.",
      "action": "Register as a partner"
    },
    "cta": "Every act counts. Start making a difference today.",
    "categories_kicker": "Good deeds in everyday life",
    "categories_title": "Explore the ten categories",
    "categories_description": "From helping with groceries to protecting nature: each category offers another way to contribute."
  },
  "partnerSettings": {
    "title": "Partner area",
    "loadError": "Could not load settings",
    "required": "Required",
    "failed": "Could not save changes.",
    "pending": "Under review",
    "vat": "VAT / tax number",
    "bio": "Business description / About us",
    "create": "New offer",
    "company": "Company",
    "category": "Category",
    "status": "Status",
    "active": "Active",
    "inactive": "Inactive",
    "save": "Save",
    "saved": "Profile saved.",
    "error": "Error saving profile.",
    "noOffers": "No offers found.",
    "loading": "Loading…",
    "offers": "Offers",
    "preview": "Preview"
  },
  "guild_treasury": {
    "error": "An error occurred.",
    "requires_boost": "Unlock {{name}} first",
    "already": "Already unlocked.",
    "shop_eyebrow": "GUILD SHOP",
    "balance": "Available balance",
    "catalog": "Unlocks & Catalog",
    "unlocked": "Unlocked",
    "unlock": "Unlock",
    "ledger": "Transaction History (Ledger)",
    "empty": "No transactions yet.",
    "reward": "Reward",
    "purchase": "Purchase",
    "after": "Balance after"
  },
  "guildGildexTreasury": {
    "balance": "Current balance",
    "payout": "Distribution",
    "history": "Transaction history",
    "empty": "No transactions yet.",
    "reason": "Reason",
    "amount": "Amount",
    "date": "Date"
  },
  "adminHeroicActions": {
    "restartReview": "Start a new review round",
    "restartReviewPrompt": "Previous votes remain in the history but no longer count. The new round uses the current review thresholds. A reason is optional.",
    "restartReviewReason": "Reason (optional)",
    "restartReviewSuccess": "New review round started.",
    "returnSubmission": "Return for revision",
    "returnReason": "Reason shown to the user:",
    "backToSubmissions": "← Back to submissions",
    "submissionDetails": "Review submission",
    "proofSection": "Evidence and group details",
    "decisionSection": "Review and decision",
    "submitterTitle": "Submitted by",
    "reviewContextTitle": "Profile card and submission history",
    "reviewContextLoading": "Loading profile card …",
    "reviewContextError": "Could not load the profile card and history.",
    "reviewContextForbidden": "You do not have a valid review assignment for this submission.",
    "reviewContextRetry": "Try again",
    "showRecentActions": "Show last 10 good deeds",
    "hideRecentActions": "Hide recent good deeds",
    "recentActionsTitle": "Last 10 submitted good deeds",
    "noRecentActions": "No previous submissions.",
    "similarActionsNotice_one": "A previous submission has a similar title or description:",
    "similarActionsNotice_other": "{{count}} previous submissions have similar titles or descriptions:",
    "similarityCaution": "Check the date and evidence; similarity alone does not establish a duplicate.",
    "similarFields": "Similar: {{fields}}",
    "similarTitle": "title",
    "similarDescription": "description",
    "and": "and",
    "loadingDetails": "Loading submission …",
    "submissionNotFound": "This submission was not found.",
    "tableTitle": "Submission",
    "deleteRewards": "Rewards on deletion",
    "chooseDeleteMode": "Choose an option",
    "keepRewards": "Keep rewards",
    "reverseRewards": "Reverse rewards",
    "deleteSubmission": "Delete submission",
    "deleted": "Submission deleted.",
    "deleteConfirmation": "Permanently delete “{{title}}”, including evidence and reviews?",
    "reviewUnavailable": {
      "own": "You cannot approve your own submission. Another assigned reviewer must review it.",
      "evidence": "Approval requires successfully uploaded evidence.",
      "status": "This status does not allow another approval.",
      "already": "You have already voted in this review round. A system admin can start a new review round if needed."
    },
    "reviewCategory": "Category",
    "queueScope": "View",
    "allSubmissions": "All submissions",
    "assignedSubmissions": "Reviews assigned to me",
    "submissionsCount": "submissions",
    "noSubmissions": "No submissions found",
    "allSubmissionsHint": "Submissions from all users and in every status are shown here, including pending or failed uploads.",
    "awaitingUploadHint": "The evidence upload has not completed. This submission is not ready for review yet.",
    "submittedAt": "Submitted on",
    "submissionStatuses": {
      "AwaitingEvidence": "Evidence missing / upload pending",
      "PendingReview": "Pending review",
      "Approved": "Approved",
      "Rejected": "Rejected",
      "Returned": "Returned for revision",
      "Withdrawn": "Withdrawn",
      "Draft": "Draft"
    },
    "review": "Review good deed",
    "approve": "Approve",
    "reject": "Reject",
    "reason": "Reason for rejection",
    "noPending": "No pending submissions available",
    "noActions": "No pending submissions available",
    "noMatchingActions": "No submissions match your current filter criteria.",
    "noPendingDesc": "There are currently no assigned good deeds to review. New submissions will appear here automatically.",
    "error": "Error loading good deeds.",
    "saving": "Saving…",
    "allCategories": "All categories",
    "allDifficulties": "All effort levels",
    "resetFilters": "Reset filters",
    "filterTitle": "Filters & Search",
    "activeFilters": "active",
    "filtersOpen": "Expand filters",
    "filtersClosed": "Collapse filters",
    "search": "Search",
    "category": "Category",
    "difficulty": "Time and effort",
    "pendingCount": "{{count}} good deeds to review",
    "singlePendingCount": "1 good deed to review",
    "noApplications": "No pending applications.",
    "noMotivation": "No motivation provided.",
    "appeals": "Appeals",
    "appealStatusLabels": {
      "Pending": "Appeal pending",
      "Approved": "Appeal accepted",
      "Rejected": "Appeal dismissed"
    },
    "noAppeals": "No pending appeals.",
    "by": "by",
    "appealRound": "Review round",
    "newReview": "Review again",
    "dismiss": "Dismiss",
    "actions": "Pending Good Deeds",
    "group": "Group",
    "reviews": "Reviews",
    "binding": "Binding initial classification",
    "afterBonus": "After bonuses",
    "guidanceMulti": "Multiple reviews required for final approval.",
    "guidanceSingle": "Single review sufficient.",
    "classifyApprove": "Classify & Approve",
    "confirm": "Approve",
    "adminRequired": "Admin review",
    "rejectReason": "Reason for rejection:",
    "reviewFailed": "Review failed.",
    "approved": "Accepted",
    "denied": "Rejected",
    "applicationFailed": "Moderator application decision failed.",
    "appealApprovePrompt": "Reason for re-review:",
    "appealRejectPrompt": "Reason for dismissing appeal:",
    "appealFailed": "Appeal decision failed."
  },
  "adminAppeals": {
    "title": "Appeals",
    "intro": "Pending appeals against rejected good deeds.",
    "detailTitle": "Decide appeal",
    "back": "All appeals",
    "pending": "Appeal pending",
    "submitted": "Submitted on",
    "reason": "Reason for appeal",
    "viewSubmission": "View submission",
    "open": "Open case",
    "loading": "Loading appeals…",
    "loadFailed": "Appeals could not be loaded.",
    "noLongerPending": "This appeal is no longer pending.",
    "accepted": "Appeal accepted. A new review round will begin.",
    "dismissed": "Appeal dismissed."
  },
  "quick_heroic_action": {
    "ability_available": "Available this week.",
    "ability_used": "Used. Available again: {{date}}.",
    "back_to_dashboard": "← Dashboard",
    "eyebrow": "Good deed",
    "title": "Quick submission",
    "intro": "Take a photo or video, add a short description, and submit.",
    "notice": "Quick submissions may receive a lower rating or take longer to verify.",
    "recovery_error": "Your last submission could not be checked. Review your submissions before creating another.",
    "invalid_file_type": "Choose a JPG, PNG, WebP image or an MP4 video.",
    "file_too_large": "The file must be no larger than 10 MB.",
    "evidence_missing": "Submission created, but evidence is still missing: {{message}}",
    "submission_failed": "Submission failed.",
    "created_resume": "Your submission was already created. Select the evidence file again to finish the upload.",
    "success_title": "Submission sent",
    "success_body": "Your evidence was uploaded and your good deed is awaiting review.",
    "view_submissions": "View my submissions",
    "evidence_heading": "Photo or video",
    "take_photo": "Take photo",
    "record_video": "Record video",
    "choose_file": "Choose file",
    "description_label": "Short description",
    "description_placeholder": "What did you do?",
    "submitting": "Submitting…",
    "retry_upload": "Retry evidence upload",
    "submit": "Submit now",
    "manage_submission": "Manage this submission and its evidence",
    "full_form": "Use the full good deed form"
  },
  "heroicActions": {
    "draft": "Draft",
    "returnReason": "Reason for return",
    "addEvidenceOptional": "Add more evidence (optional)",
    "selectedUploadsHint": "All selected files will be submitted together. You can add other types of evidence.",
    "choosePdfFiles": "Choose PDF documents",
    "choosePhotos": "Choose photos",
    "fileTypeMismatch": "Please choose files matching the selected evidence type.",
    "removeEvidence": "Remove evidence",
    "removeEvidenceConfirm": "Permanently remove “{{name}}”? Deletion takes effect immediately, even if you cancel editing afterwards.",
    "existingEvidence": "Existing evidence",
    "existingEvidenceHint": "This evidence is retained when you withdraw and reused when you resubmit. You can add more files.",
    "chooseFiles": "Choose photos / files",
    "removeFile": "Remove",
    "selectFilesFirst": "Select at least one file to enable the evidence upload.",
    "remainingEvidence": "Some evidence has been uploaded. You can retry the remaining files here.",
    "uploading": "Uploading evidence …",
    "title": "Good Deed",
    "back_to_overview": "Back to good deeds overview",
    "rules_title": "Guidance & rules",
    "submissions_title": "Your submissions",
    "start_title": "Start a good deed",
    "pageSubtitle": "Small acts. Big impact.",
    "subtitle": "Small acts of kindness count: listen to someone, help carry a bag, or share what you know. Record your good deed.",
    "create": "New good deed",
    "newWithSlots": "New good deed ({{occupied}} / {{maximum}})",
    "newWithSlotsHint": "{{free}} free slots, {{occupied}} occupied slots",
    "slots_full_title": "Good Deed",
    "slots_full_banner_hint": "Drafts are possible: Save now and submit later.",
    "titlePlaceholder": "Title",
    "descriptionPlaceholder": "What did you do?",
    "estimate": "Roughly estimate the time and planning involved. The team will review your choices later.",
    "selfReport": "No visual evidence",
    "photo": "Photo",
    "photoGps": "Photo with location",
    "document": "Document",
    "privacy": "I confirm that the evidence does not show uninvolved people, license plates, private addresses, or sensitive documents. The file is encrypted and deleted after the retention period.",
    "submitting": "Submitting…",
    "submit": "Submit good deed",
    "privacyRequired": "Select an evidence file and confirm the privacy rules.",
    "gpsRequired": "Please enable GPS location first.",
    "gpsActivate": "Enable GPS location",
    "gpsLoading": "Getting your location…",
    "gpsReady": "GPS location captured",
    "gpsError": "Your location could not be determined. Check browser permission and try again.",
    "gpsUnsupported": "GPS is not supported by this browser.",
    "dropTitle": "Drop file here",
    "dropHint": "or click to choose a file",
    "selectedFile": "Selected",
    "submitted": "Good deed submitted and awaiting review.",
    "successEyebrow": "All done",
    "successTitle": "Good deed submitted!",
    "successDescription": "“{{title}}” was submitted successfully.",
    "successStatus": "Your good deed is now awaiting review.",
    "viewSubmission": "View submission",
    "closeSuccess": "Close success message",
    "submitFailed": "Could not submit the good deed.",
    "mine": "My submissions",
    "empty": "No good deeds submitted yet.",
    "estimateShort": "Guidance",
    "statusOpen": "Open",
    "statusOpenOption": "Open (Under review & Evidence)",
    "approved": "Approved",
    "awaitingEvidence": "Your submission is saved. The evidence upload has not completed yet.",
    "upload": "Upload evidence",
    "uploaded": "Evidence uploaded securely.",
    "uploadFailed": "Upload failed.",
    "appealPrompt": "Explain your appeal (at least 20 characters)",
    "appealSubmitted": "Appeal submitted.",
    "appealFailed": "Could not submit the appeal.",
    "appeal": "File appeal",
    "appealStatus": "Appeal",
    "erneut_versuchen": "Try again",
    "details_erg_nzen_und": "Add details and resubmit",
    "zur_ck": "Back",
    "einmalig_reparieren": "Repair once",
    "abbrechen": "Cancel",
    "reparatur_bereits_ve": "Repair already used.",
    "ich_lade_anschlie_en": "I will upload a new evidence later.",
    "setze_ein_zeichen_in": "Make a difference for others.",
    "berarbeite_die_anga": "Revise the details. Without a new file, the existing evidence will be reused.",
    "zur_ckgezogene_einre": "Withdrawn submission",
    "nachweistyp": "Evidence type",
    "einstufung": "Classification",
    "w_hle_deine_kategori": "Choose your category and document your action.",
    "fehlende_nachweise_k": "You can add missing evidence to the relevant submission. In case of rejection, you can submit a justified appeal there.",
    "zeitpunkt_der_helden": "Time of good deed",
    "filterTitle": "Filter & Search",
    "searchPlaceholder": "Search description or title…",
    "allCategories": "All Categories",
    "category": "Category",
    "filterDate": "Date",
    "allDates": "All Timeframes",
    "dateToday": "Today",
    "dateWeek": "Last 7 Days",
    "dateMonth": "Last 30 Days",
    "dateYear": "This Year",
    "dateCustom": "Custom Range",
    "dateFrom": "From",
    "dateTo": "To",
    "sort": "Sort By",
    "sortDateDesc": "Date (Newest first)",
    "sortDateAsc": "Date (Oldest first)",
    "status": "Status",
    "allStatuses": "All Statuses",
    "resetFilters": "Reset Filters",
    "activeFilters": "Active Filters:",
    "filterCount": "{{count}} of {{total}} submissions",
    "noMatchingActions": "No submissions match your selected filter criteria.",
    "calculation": "Calculation",
    "breakdown": {
      "event": "System event",
      "party": "Party bonus",
      "partyCap": "Party bonus capped at 50%",
      "reconstructed": "The personal share was reconstructed; the actual credit appears below.",
      "personalModifier": "{{name}}: {{percent}} on the personal share",
      "personalFormula": "Personal calculation: ⌊{{share}} × (1 + {{percent}}%)⌋",
      "soloFormula": "Calculation: ⌊{{base}} × {{event}} × (1 + {{percent}}%)⌋"
    }
  },
  "heroicActionXpGuide": {
    "difficulty": "Time and effort",
    "complexity": "Planning and coordination",
    "example": "Example",
    "assessment": "Assessment",
    "reason": "Rationale",
    "footer": "Donation or product value, dangerous behavior, and a particular outcome of an authority report are not rewarded. Only documented personal effort, credible delivery, and actual planning and coordination count. Evidence images should avoid bystanders, license plates, and private addresses.",
    "simpleDifficulty": "How much time and effort?",
    "simpleComplexity": "How much planning and coordination?",
    "assessmentHint": "Choose a rough estimate. The team will review it later.",
    "close": "Close",
    "groupOnly": "Group actions only",
    "groupBandTitle": "Group band {{band}}",
    "bandTitle": "Band {{band}}",
    "groupExamples": [
      {
        "title": "Clean a small section of a park together",
        "difficulty": "LOW",
        "complexity": "SIMPLE",
        "rationale": "A short shared task with a documented result.",
        "band": 1
      },
      {
        "title": "Maintain a neighborhood garden as a team",
        "difficulty": "MEDIUM",
        "complexity": "SIMPLE",
        "rationale": "Meaningful joint effort without extensive coordination.",
        "band": 2
      },
      {
        "title": "Collect and distribute rescued food together",
        "difficulty": "MEDIUM",
        "complexity": "COORDINATED",
        "rationale": "Coordinate collection, volunteers and handover.",
        "band": 3
      },
      {
        "title": "Prepare a shared repair day",
        "difficulty": "HIGH",
        "complexity": "COORDINATED",
        "rationale": "Several hours of teamwork with materials and an agreed schedule.",
        "band": 4
      },
      {
        "title": "Run a larger collection drive with transport",
        "difficulty": "HIGH",
        "complexity": "COMPLEX",
        "rationale": "Responsibilities, routes and recipients need to fit together.",
        "band": 5
      },
      {
        "title": "Carry out a longer-term aid project as a team",
        "difficulty": "EXCEPTIONAL",
        "complexity": "COMPLEX",
        "rationale": "Several days or sessions with documented contributions and planning.",
        "band": 6
      },
      {
        "title": "Improve a community space over several workdays",
        "difficulty": "EXTENSIVE",
        "complexity": "COMPLEX",
        "rationale": "Extensive documented teamwork with materials and work planning.",
        "band": 7
      },
      {
        "title": "Complete a multi-phase community project with several organizations",
        "difficulty": "EXTENSIVE",
        "complexity": "MULTISTAGE",
        "rationale": "Substantial effort with dependent phases, several teams and documented handovers.",
        "band": 8
      }
    ]
  },
  "heroicActionXpGuideData": {
    "difficulty": {
      "LOW": [
        "Low",
        "Short, low-risk effort with limited personal strain."
      ],
      "MEDIUM": [
        "Medium",
        "Noticeable personal effort or preparation."
      ],
      "HIGH": [
        "High",
        "Substantial time, responsibility, or physical effort."
      ],
      "EXCEPTIONAL": [
        "Very high",
        "Several days of effort or a contribution that continues over time. No risk is needed."
      ],
      "EXTENSIVE": [
        "Extensive team effort",
        "Groups only: substantial joint work across several workdays or recurring sessions with documented contributions. Group size alone is not enough."
      ]
    },
    "complexity": {
      "SIMPLE": [
        "Simple",
        "You can start right away and do the task on your own."
      ],
      "COORDINATED": [
        "Some coordination",
        "You need some preparation or need to check in with others."
      ],
      "COMPLEX": [
        "A lot to plan",
        "Several people, dates, or steps need to come together."
      ],
      "MULTISTAGE": [
        "Multi-stage organization",
        "Groups only: several teams or organizations, dependent phases, clear responsibilities and coordinated handovers."
      ]
    },
    "titles": {
      "Gefahrenstelle (z. B. Glasscherben) auf Spielplatz oder Radweg beseitigen": "Clear a hazard (e.g. broken glass) from a playground or bike path",
      "Umweltproblem mit Foto und Standort melden": "Report an environmental issue with photo and location",
      "Schlagloch bei der Gemeinde melden": "Report a pothole to the municipality",
      "Illegale Müllablagerung melden": "Report illegal waste dumping",
      "Barriere auf einem Gehweg dokumentieren": "Document an accessibility barrier on a pavement",
      "Einen Sack Müll in der Umgebung sammeln": "Collect a bag of litter in your area",
      "Futterspende beim lokalen Tierheim abgeben": "Deliver a pet-food donation to a local shelter",
      "Einkauf für eine benachbarte Person erledigen": "Shop for a neighbor",
      "Eine Stunde Nachhilfe geben": "Provide one hour of tutoring",
      "Kleines defektes Alltagsgerät für jemanden reparieren": "Repair a small everyday device for someone",
      "Lebensmittel bei einer Rettungsstelle abholen und verteilen": "Collect and distribute rescued food",
      "Nachbarschaftshilfe bei Gartenarbeit oder Umzug": "Help a neighbor with gardening or moving",
      "Vorbereiteten Wissensworkshop durchführen": "Run a prepared educational workshop",
      "Als Imker-Pate einen betreuten Praxistermin durchführen": "Mentor a practical beekeeping session",
      "Kleine gemeinsame Müllsammelaktion organisieren": "Organize a small community clean-up",
      "Hilfsgüter für eine lokale Einrichtung sortieren": "Sort relief supplies for a local organization",
      "Fahrrad-Reparaturhilfe für mehrere Personen anbieten": "Offer bicycle repair help to several people",
      "Barrierefreiheit eines ganzen Straßenabschnitts erfassen": "Survey accessibility along an entire street section",
      "Erste-Hilfe-Auffrischung in einer Gruppe organisieren": "Organize a group first-aid refresher",
      "Mehrteilige Lernbegleitung übernehmen": "Provide a multi-session learning program",
      "Spendenaktion für ein Tierheim koordinieren": "Coordinate a donation drive for an animal shelter",
      "Öffentlichen Reparatur-Nachmittag mitorganisieren": "Co-organize a public repair afternoon",
      "Größere Aufräumaktion mit Entsorgung organisieren": "Organize a larger clean-up with disposal",
      "Mehrwöchige Imker- oder Handwerks-Patenschaft": "Run a multi-week beekeeping or craft mentorship",
      "Lokales Bildungsprogramm über mehrere Termine durchführen": "Run a local educational program across several sessions",
      "Regelmäßige Lebensmittelrettung für eine Einrichtung aufbauen": "Set up recurring food rescue for an organization",
      "Gemeinschaftsfläche mit Zustimmung nachhaltig aufwerten": "Improve a community space sustainably and with permission",
      "Nachbarschaftliches Hilfsnetzwerk aufbauen": "Build a neighborhood support network",
      "Große Sachspendenlogistik für mehrere Einrichtungen koordinieren": "Coordinate large-scale in-kind donation logistics",
      "Mehrmonatige Lern- oder Berufspatenschaft abschließen": "Complete a multi-month learning or career mentorship",
      "Gemeinnützige digitale Lösung entwickeln und einführen": "Develop and deploy a public-benefit digital solution"
    },
    "rationale": [
      "Short, verifiable contribution with limited effort.",
      "Clear personal effort with a verifiable result.",
      "Moderate effort or coordination supported by evidence.",
      "High effort or complex delivery supported by evidence.",
      "Very demanding or multi-day contribution with clear impact.",
      "Exceptional, sustained community project with documented impact."
    ]
  },
  "guild_administration": {
    "name_placeholder": "e.g. Guardians of the North",
    "latitude": "Latitude (Lat)",
    "longitude": "Longitude (Lng)",
    "latitude_placeholder": "e.g. 48.2082",
    "longitude_placeholder": "e.g. 16.3738",
    "saving": "Saving...",
    "save_profile": "Save details & location",
    "latitude_invalid": "Please enter a valid latitude (-90 to 90).",
    "longitude_invalid": "Please enter a valid longitude (-180 to 180).",
    "save_failed": "Could not save changes.",
    "customize_emblem": "Customize emblem",
    "forging": "Forging...",
    "save_emblem": "Save emblem",
    "discard_emblem_changes": "Discard changes",
    "forge_shop_link": "View upgrade in shop",
    "theme_title": "Guildhall Design & Room Style",
    "theme_eyebrow": "Guildhall · Room styles",
    "theme_current": "Current view",
    "theme_in_use": "In use",
    "theme_to_shop": "View in shop",
    "theme_select": "Use this style",
    "theme_default": "Standard Keep",
    "theme_default_description": "Your familiar guildhall with a classic castle atmosphere.",
    "theme_forest": "Forest Hall",
    "theme_forest_description": "A warm hall among trees and moss covered walls.",
    "theme_celestial": "Celestial Hall",
    "theme_celestial_description": "A grand hall filled with light and starlight.",
    "active": "Active",
    "available_default": "Available (default)",
    "unlocked": "Unlocked",
    "locked": "Locked",
    "theme_saved": "Your guildhall view was updated.",
    "applications_title": "Pending Join Applications ({{count}})",
    "no_applications": "No pending applications.",
    "application_approved": "Application from \"{{name}}\" approved.",
    "application_denied": "Application from \"{{name}}\" denied.",
    "application_blocked": "Application from \"{{name}}\" permanently blocked.",
    "action_failed": "Action failed.",
    "submitted_at": "Submitted: {{date}}",
    "block_user_title": "Permanently block user",
    "banned_since": "Banned since: {{date}}",
    "unbanning": "Removing ban...",
    "unban": "Remove ban",
    "ban_failed": "Could not ban member.",
    "unban_success": "Ban for \"{{name}}\" removed.",
    "unban_failed": "Could not remove ban."
  },
  "guildDetail": {
    "heroic_actions": "Good deeds",
    "member_directory": "Member Directory",
    "roster_flyout": "Members ({{count}})",
    "roster_page": "{{count}} members · Page {{page}} / {{total}}",
    "einige_wappen_erford": "Some emblems require",
    "lade_verbannungen": "Loading bans...",
    "lade_bewerbungen": "Loading applications...",
    "nachfolger_ernennen": "Appoint successor",
    "keine_offenen_bewerb": "No pending applications.",
    "abbrechen": "Cancel",
    "anpassen": "Customize",
    "kicken": "Kick",
    "bannen": "Ban",
    "annehmen": "Accept",
    "blockieren": "Block",
    "aktuelles_wappen": "Current emblem",
    "erweiterte_wappensch": "Advanced emblem forge",
    "mitglieder_suchen": "Search members",
    "keine_mitglieder_gef": "No members found.",
    "ablehnen": "Reject",
    "name_eingeben_placeholder": "Enter name"
  },
  "adminClassCategoryManager": {
    "noch_keine_perks_zug": "No perks assigned yet.",
    "lucide_icon_name": "Lucide Icon Name",
    "perk_speichern": "Save perk",
    "lade_kategorien": "Loading categories...",
    "abbrechen": "Cancel",
    "speichern": "Save",
    "alle_kategorien": "All categories",
    "keine_kategorien_vor": "No categories available.",
    "anzeigename": "Display name",
    "neue_kategorie": "New category",
    "inaktiv": "Inactive",
    "beschreibung": "Description",
    "perk_hinzuf_gen": "Add perk",
    "entfernen": "Remove",
    "aktiv_im_system": "Active in system",
    "einmalige_reparatur": "One-time repair",
    "beschreibung_was_zu_placeholder": "Description of what belongs to this category...",
    "shield_compass_zap_placeholder": "Shield, Compass, Zap..."
  },
  "gameMechanics": {
    "how": "How",
    "goodvale": "Goodvale",
    "verschl_sselt": "Encrypted",
    "works": "Works",
    "zum_dashboard": "To Dashboard",
    "kein_geldwert": "No monetary value",
    "keine_tokens": "No tokens",
    "unabh_ngig": "Independent",
    "fristgerechte_l_schu": "Timely deletion",
    "jetzt_registrieren": "Register now",
    "mehrheitsbeschluss": "Majority decision",
    "nicht_kommerziell": "Non-commercial",
    "so_funktioniert": "How it works",
    "perk": "Perk",
    "einspruchsrecht": "Right of appeal",
    "keine_bezahlten_auft": "No paid jobs",
    "rein_dekorativ": "Purely decorative",
    "nulltoleranz_f_r_man": "Zero tolerance for manipulation",
    "heldentat_starten": "Start good deed"
  },
  "guildMembersAdmin": {
    "fehler_beim_laden": "Error loading",
    "lade_offene_bewerbun": "Loading pending applications...",
    "abbrechen": "Cancel",
    "blockieren": "Block",
    "kicken": "Kick",
    "mitglieder": "Members",
    "ablehnen": "Reject",
    "bannen": "Ban",
    "annehmen": "Accept",
    "keine_offenen_bewerb": "No pending applications"
  },
  "systemEvents": {
    "status_start": "Starts",
    "status_end": "Ends",
    "status_on_day": "Ongoing",
    "erneut_versuchen": "Try again",
    "keine_passenden_even": "No matching events available. You can document a free good deed at any time.",
    "alle_kategorien": "All Categories",
    "events_konnten_nicht": "Failed to load events.",
    "current_system_events": "Current System Events",
    "title": "Event Calendar & System Events",
    "subtitle": "Overview of all worldwide campaigns, bonuses and dates",
    "show_all_events": "Show all events →",
    "tab_all": "All Events",
    "tab_active": "Active Now",
    "tab_upcoming": "Upcoming",
    "tab_past": "Ended",
    "category_select_label": "Event Category",
    "loading": "Loading events …",
    "prev_month": "Previous month",
    "next_month": "Next month",
    "today_button": "Today: {{date}}",
    "legend_start": "Start",
    "legend_end": "End",
    "legend_active": "Active",
    "weekdays": [
      "Mon",
      "Tue",
      "Wed",
      "Thu",
      "Fri",
      "Sat",
      "Sun"
    ],
    "today": "Today",
    "today_upper": "TODAY",
    "more_events": "+{{count}} more",
    "click_for_day": "Click for daily overview →",
    "today_selected": "✦ Today selected day",
    "selected_date": "Selected date",
    "active_events_count_one": "1 event active",
    "active_events_count_other": "{{count}} events active",
    "marked_in_calendar": "Marked in calendar",
    "clear_mark": "Clear mark",
    "highlighted_badge": "Marked",
    "details": "Details →",
    "no_events_on_day": "No active system events taking place on this day.",
    "back_to_today": "Back to today ({{date}}) →",
    "status_active": "Active",
    "status_upcoming": "Upcoming",
    "status_ended": "Ended",
    "page_title": "Events",
    "page_subtitle": "Making a difference together.",
    "page_description": "Discover current campaigns, their conditions, and opportunities to contribute.",
    "back_to_all_events": "← All Events",
    "back_to_heroic_actions": "← Good Deeds",
    "event_load_error": "This event could not be loaded.",
    "event_loading": "Loading event …",
    "your_task": "Your Task",
    "reward_and_participation": "Reward & Participation",
    "max_submissions": "Maximum {{count}} submissions per person.",
    "terms_apply": "Participation subject to event conditions.",
    "notes_and_evidence": "Notes & Evidence",
    "default_safety_rules": "Document your contribution clearly. The submission will be reviewed.",
    "verification_method": "Verification method",
    "evidence_review": "Review of submitted evidence",
    "submit_action_for_event": "Submit good deed →",
    "participation_starts_at_date": "Participation begins on the specified start date.",
    "event_is_ended": "This event has ended."
  },
  "worldMapView": {
    "mitglieder": "Members",
    "legende": "Legend",
    "ber_diesen_ort": "About this place",
    "alle": "All",
    "kategorie": "Category",
    "einige_kartenkacheln": "Some map tiles could not be loaded. Check your connection and pan or zoom the map to load more tiles.",
    "kartenfilter": "Map filter",
    "keine": "None",
    "openstreetmap": "OpenStreetMap",
    "partners": "Partners",
    "locating": "Determining location …",
    "location_centered": "Map centered on your location.",
    "location_unavailable": "Location unavailable. You can still move the map freely.",
    "my_location": "My location",
    "locations_count": "{{count}} locations",
    "partner_offer_type": "Partner Offer",
    "partner_offers_at_location": "Offers at this location",
    "offer_by": "Offer by: {{name}}",
    "requirements": "Requirements",
    "leader_prefix": "Leader: {{name}}",
    "no_description": "No description provided for this location yet.",
    "interactive_map": "Interactive World Map",
    "map_tools": "Map information and filters",
    "location_details": "Location Details",
    "close_details": "Close location details",
    "discover_world": "Discover the World",
    "view_partner": "View Partner Page & Offers"
  },
  "partnerDetail": {
    "offer_unavailable": "The offer or partner does not exist or is currently inactive.",
    "onsite_only": "This offer can only be redeemed on site.",
    "opening_contact_notice": "The partner's opening hours apply. Please contact the partner yourself if needed.",
    "title": "Partner Business",
    "digital_error": "Redemption failed.",
    "redeem_digital_btn": "Redeem online",
    "digital_redemption_title": "Digital redemption",
    "redeeming": "Redeeming voucher …",
    "redeem_failed": "Redemption unavailable",
    "close": "Close",
    "redeem_success": "Successfully redeemed!",
    "your_coupon_code": "Your coupon code",
    "copied": "Copied!",
    "copy_code": "Copy code",
    "instructions": "Redemption instructions",
    "open_webshop": "Open online store / website",
    "done": "Done",
    "back": "Back",
    "back_to_map": "To World Map",
    "loading": "Loading partner details …",
    "load_error": "Could not load partner business.",
    "not_found_title": "Partner Not Found",
    "not_found_desc": "This partner business does not exist or is currently inactive.",
    "verified_partner": "Verified Partner Business",
    "view_on_map": "View on World Map",
    "show_qr_pass": "My QR Pass",
    "partner_since": "Partner since {{date}}",
    "no_offers_title": "No Active Offers",
    "no_offers_desc": "This partner business currently has no active offers. Check back soon!",
    "location": "Location & Directions",
    "coordinates": "Coordinates",
    "open_google_maps": "Open in External Maps",
    "how_to_redeem_title": "Redeem Offer In-Store",
    "open_pass_btn": "Show QR Pass"
  },
  "heroicOverview": {
    "all_submissions": "All submissions",
    "drafts": "Drafts",
    "draft": "Draft",
    "no_submissions": "No submissions yet.",
    "no_drafts": "No drafts yet.",
    "show_drafts": "Show drafts",
    "letzte_heldentaten": "Recent Good Deeds",
    "keine_heldentaten": "No confirmed good deeds yet.",
    "alle_heldentaten_a": "Show all confirmed good deeds",
    "offene_einreichungen_anzeigen": "Show open submissions",
    "nachweise_sorgf_ltig": "Choose evidence carefully",
    "lade_deinen_nachweis": "Upload your evidence for the corresponding good deed. Select a pending submission for this.",
    "erhaltene_belohnunge": "Received rewards",
    "offene_einreichungen": "Pending submissions",
    "alle_einreichungen_a": "Show all submissions",
    "r_ckfragen_zur_pr_fu": "Answer questions for review",
    "keine_offenen_einrei": "No pending submissions. Ready for your next good deed?",
    "alle_regeln_anzeigen": "Show all rules",
    "nachweis_hochladen": "Upload evidence",
    "eigene_beitr_ge_doku": "Document own contributions",
    "loading_submissions": "Loading submissions …",
    "awaiting_evidence": "Evidence required",
    "pending_review": "Under review",
    "upload_evidence": "Upload evidence",
    "progress_loading": "Loading progress.",
    "confirmed_actions_count": "{{count}} confirmed good deeds. Every contribution counts.",
    "guidance_and_rules": "Guidelines & Rules"
  },
  "guild_overview": {
    "announcements_and_actions": "Announcements & Good Deeds",
    "show_all": "Show all →",
    "loading_announcements": "Loading announcements …",
    "no_announcements": "No announcements yet.",
    "next_stage_from": "{{detail}} from {{min}} Renown",
    "max_stage_reached": "Your hall has reached its highest upgrade stage.",
    "view_stages_decorations": "View upgrade stages & decorations",
    "group_activity": "Group Activity",
    "filter_total": "Total",
    "filter_year": "This Year",
    "filter_week": "This Week",
    "heroic_actions": "Good Deeds",
    "group_heroic_actions": "Group Good Deeds",
    "all_members_total": "Total confirmed contributions.",
    "year_members_total": "Confirmed contributions this year.",
    "week_members_total": "Confirmed contributions since Monday.",
    "show_all_members": "Show all members →",
    "loading": "Loading …",
    "retry": "Try again",
    "ep_boost_level": "Level {{level}}",
    "ep_boost_stage": "Level {{current}} of {{max}}"
  },
  "guild_hall_stage": {
    "renown_suffix": "({{renown}} Renown)",
    "default_theme": "Stronghold",
    "default_theme_tooltip": "Default Hall",
    "forest_theme": "Forest",
    "forest_theme_tooltip": "Forest Hall",
    "celestial_theme": "Celestial",
    "celestial_theme_tooltip": "Celestial Hall",
    "banner_crest_alt": "Crest",
    "notice_board_aria": "Notice Board: Announcements and Good Deeds",
    "notice_board_sprite_alt": "Notice Board",
    "notice_board_title": "Notice Board",
    "profile_wall_sprite_alt": "Profile Wall",
    "profile_wall_title": "Members ({{count}})",
    "trophy_shelf_aria": "Trophy Shelf",
    "trophy_shelf_sprite_alt": "Trophy Shelf",
    "trophy_shelf_unlocked": "Trophy Chamber",
    "fame_monument_aria": "Fame Monument & Good Deeds",
    "fame_monument_sprite_alt": "Fame Monument",
    "fame_monument_title": "Fame Monument",
    "chest_sprite_alt": "Treasure Chest",
    "stammtisch_sprite_alt": "Stammtisch",
    "group_table_aria": "Conference Table for Group Actions",
    "group_table_sprite_alt": "Conference Table",
    "admin_desk_sprite_alt": "Admin Desk",
    "anvil_sprite_alt": "Crest Anvil",
    "anvil_unlocked": "Crest Anvil (Emblem Builder)"
  },
  "system_admin": {
    "console_title": "System Admin Console",
    "system_admin": "System Administration",
    "admin_view": "Admin View"
  },
  "partner_portal": {
    "pos": "Redeem",
    "manage_offers": "Manage Offers",
    "redemptions": "Redemption History",
    "my_profile": "Partner Profile",
    "settings": "Settings",
    "categorization": "Categorization",
    "b2b_dashboard": "Partner Dashboard",
    "verified_partner": "Verified Partner",
    "partner_view": "Partner View",
    "console_title": "Partner Dashboard"
  },
  "partner_redemptions": {
    "title": "Redemption History",
    "load_error": "Failed to load redemption history.",
    "loading": "Loading redemptions …",
    "stat_total": "Total Redemptions",
    "stat_onsite": "On-Site (POS)",
    "stat_digital": "Remote / Digital",
    "filter_all": "All",
    "filter_onsite": "On-Site",
    "filter_digital": "Digital",
    "mode_onsite": "On-Site (POS)",
    "mode_digital": "Remote / Digital",
    "code_label": "Code",
    "status_confirmed": "Redeemed",
    "no_matching_results": "No redemptions found matching your filters.",
    "try_reset_filter": "Try adjusting your search terms or selecting a different filter.",
    "no_redemptions_yet": "No redemptions yet."
  },
  "partner_profile": {
    "title": "Partner Profile & Location",
    "subtitle": "Manage your company profile, logo, banner, and location on the world map.",
    "view_public_page": "Public View",
    "view_on_map": "View on Map",
    "change_banner": "Change Banner",
    "reset_banner": "Default Banner",
    "banner_saved": "Banner saved successfully.",
    "banner_reset": "Default banner restored.",
    "banner_error": "Failed to update banner.",
    "change_logo": "Change Logo",
    "verified_partner": "Verified Partner Business",
    "pending_review": "Under Review (Pending Approval)",
    "partner_since": "Partner since {{date}}",
    "company_default": "Partner Business",
    "basic_info": "Company Details & Industry",
    "company_name": "Company / Business Name *",
    "company_required": "Please provide a company name.",
    "category": "Main Category / Industry *",
    "vat_id": "VAT / Tax ID (optional)",
    "partner_id": "Partner ID",
    "bio": "About this Business / Description",
    "location_title": "World Map Location",
    "location_desc": "Determines where your business and active offers appear on the interactive world map.",
    "latitude": "Latitude",
    "longitude": "Longitude",
    "invalid_lat": "Invalid latitude (-90 to 90).",
    "invalid_lng": "Invalid longitude (-180 to 180).",
    "saved_success": "Partner profile saved successfully.",
    "save_failed": "Failed to save partner profile.",
    "save_changes": "Save Changes",
    "saving": "Saving …",
    "loading": "Loading partner profile …",
    "load_error": "Failed to load partner profile."
  },
  "partner_settings": {
    "title": "Partner Settings",
    "subtitle": "Security, password, language, theme, and data management for your partner account.",
    "password_desc": "Update the password for your partner account.",
    "preferences_desc": "Customize the user interface and language according to your preferences.",
    "data_rights_desc": "Export your partner data or permanently close your partner account.",
    "delete_account": "Close & Delete Partner Account",
    "delete_confirm": "Do you really want to permanently close and anonymize this partner account? All created offers will be deleted.",
    "saving": "Changing …",
    "exporting": "Exporting …",
    "deleting": "Deleting …"
  },
  "mapPage": {
    "loading": "Loading map …",
    "error": "Failed to load locations.",
    "retry": "Try again"
  },
  "audit_ui": {
    "banner_saved": "Banner saved.",
    "banner_save_error": "Could not save banner.",
    "banner_reset": "Default banner restored.",
    "banner_reset_error": "Could not reset banner.",
    "history_error": "Could not load your history.",
    "saving": "Saving …",
    "banner_change": "Change banner",
    "reset": "Reset",
    "changing": "Changing …",
    "close_hall_image": "Close image",
    "member": "member",
    "members": "members",
    "noticeboard": "On the noticeboard",
    "news_loading": "Loading notices …",
    "news_error": "Notices are currently unavailable.",
    "news_empty": "Room for your next story.",
    "unavailable": "Currently unavailable",
    "community": "A home for your community",
    "together": "Experience more together",
    "unlockable": "Available to unlock",
    "shop_description": "Discover new rooms, hall designs and shared benefits.",
    "to_shop": "Visit shop",
    "stats": "Renown & statistics",
    "forge": "Emblem forge",
    "manage": "Administration",
    "meet_members": "Meet {{count}} members",
    "room": {
      "news": {
        "title": "Noticeboard"
      },
      "stammtisch": {
        "title": "Common room",
        "description": "Meet, chat and plan together"
      },
      "roster": {
        "title": "Member gallery"
      },
      "bounties": {
        "title": "Planning room",
        "description": "Do good deeds together"
      },
      "trophies": {
        "description": "What you have achieved together"
      },
      "design": {
        "title": "Guildhall design",
        "description": "Explore and select room styles"
      },
      "stats": {
        "title": "Renown & statistics"
      },
      "settings": {
        "title": "Administration"
      }
    },
    "name": "Name",
    "selected_title": "Selected title",
    "joined": "Joined",
    "motto": "Motto",
    "save": "Save",
    "cancel": "Cancel",
    "cancelConfirmTitle": "Cancel group action?",
    "cancelConfirm": "Do you really want to cancel “{{title}}”? Invitation notifications will be removed, and registered members will receive a cancellation notification.",
    "delete": "Delete",
    "deleteConfirmTitle": "Delete group action?",
    "deleteConfirm": "Do you really want to delete the cancelled group action “{{title}}”? It will disappear from the list. This cannot be undone.",
    "no_motto": "No motto yet.",
    "edit_motto": "Edit motto",
    "avatar_change": "Change avatar",
    "renown": [
      "Foundation",
      "Recognized",
      "Respected",
      "Famous",
      "Legendary"
    ],
    "story_subtitle": "More than a name. A story.",
    "story_description": "Your deeds tell your story.",
    "personal_data": "Personal details",
    "profile_image": "Change profile picture",
    "copy_key": "Copy key",
    "specialization": "Categories & specialization",
    "first_deeds": "Your specialization grows with your first good deeds.",
    "chronicle": "Chronicle – Recent good deeds",
    "show_all": "View all →",
    "chronicle_empty": "Your confirmed good deeds will tell your story here."
  },
  "categories_guide": {
    "title": "The ten categories",
    "assessment": "How a good deed is assessed depends on effort and complexity."
  },
  "category_showcase": {
    "gallery_label": "Explore a category",
    "eyebrow": "Your contribution matters",
    "descriptions": {
      "MOBILITY_OUTDOOR": "Help someone get around, accompany them on a journey, or make outdoor activities easier.",
      "HEALTH_WELLNESS": "Support everyday health and wellbeing without replacing medical care.",
      "ENTERTAINMENT_GASTRO": "Bring people together, create a shared experience, or organize a community event for a good cause.",
      "HARDWARE_FITNESS": "Help with exercise, training, or making good use of sports equipment.",
      "ECO_NATURE": "Care for nature, clean shared spaces, and use resources responsibly.",
      "TECH_EDUCATION": "Explain technology, share knowledge, or support someone learning.",
      "CRAFTING_REPAIR": "Repair, build, or preserve something useful to others.",
      "FOOD_GROCERIES": "Help with shopping, cooking, or distributing food.",
      "LOGISTICS_RETAIL": "Organize, transport, or distribute supplies needed for a good deed.",
      "SOCIAL_COMMUNITY": "Support others through reliable assistance and practical everyday help."
    }
  },
  "landing_classes": {
    "perks_unavailable": "Current perks are temporarily unavailable.",
    "select_class": "Select {{name}}",
    "preview_hint": "Discover your path. Choose an emblem to preview."
  },
  "good_deed_examples": {
    "title": "Good deed examples",
    "example": "Example",
    "assessment": "Assessment",
    "reason": "Reason",
    "categories_link": "Explore the categories",
    "ratings": {
      "low_simple": "Low · Simple",
      "medium_simple": "Moderate · Simple",
      "medium_coordinated": "Moderate · Coordinated",
      "high_coordinated": "High · Coordinated",
      "high_planned": "High · Complex",
      "very_high_planned": "Very high · Complex"
    },
    "rating_by_row": [
      "low_simple",
      "low_simple",
      "low_simple",
      "low_simple",
      "low_simple",
      "low_simple",
      "low_simple",
      "low_simple",
      "low_simple",
      "low_simple",
      "medium_simple",
      "medium_simple",
      "medium_simple",
      "medium_simple",
      "medium_simple",
      "medium_coordinated",
      "medium_coordinated",
      "medium_coordinated",
      "medium_coordinated",
      "high_coordinated",
      "high_coordinated",
      "high_coordinated",
      "high_coordinated",
      "high_coordinated",
      "high_coordinated",
      "high_planned",
      "high_planned",
      "high_planned",
      "high_planned",
      "very_high_planned",
      "very_high_planned",
      "very_high_planned",
      "very_high_planned",
      "very_high_planned",
      "very_high_planned",
      "very_high_planned",
      "medium_simple",
      "medium_simple",
      "medium_coordinated",
      "medium_coordinated",
      "medium_simple",
      "high_coordinated",
      "medium_coordinated",
      "high_planned",
      "high_coordinated",
      "medium_coordinated",
      "medium_simple",
      "low_simple",
      "medium_coordinated",
      null,
      null,
      "medium_coordinated",
      "high_coordinated",
      "high_planned",
      "medium_simple",
      "high_coordinated",
      "medium_coordinated",
      "high_coordinated",
      "medium_coordinated",
      "high_coordinated",
      "medium_coordinated",
      null,
      "high_coordinated",
      "medium_coordinated",
      "medium_simple",
      "medium_coordinated",
      "high_planned",
      "medium_simple",
      "high_coordinated",
      "high_planned",
      "medium_coordinated",
      "high_coordinated",
      "medium_coordinated",
      "high_coordinated",
      "medium_simple",
      "medium_coordinated",
      "high_coordinated",
      "medium_simple",
      "medium_coordinated",
      "high_coordinated",
      "medium_simple",
      "medium_coordinated",
      "high_coordinated",
      "medium_simple",
      "medium_coordinated",
      "high_planned",
      "medium_simple",
      "medium_coordinated",
      "medium_coordinated",
      "high_coordinated",
      "high_planned"
    ],
    "rows": [
      {
        "title": "Remove a hazard such as broken glass from a playground or cycle path",
        "reason": "A short, verifiable action that prevents injury or damage.",
        "xp": "1–40"
      },
      {
        "title": "Report an environmental issue with a photo and location",
        "reason": "A specific report with evidence that can be checked.",
        "xp": "1–40"
      },
      {
        "title": "Report a pothole to the local authority",
        "reason": "A local report requiring little time.",
        "xp": "1–40"
      },
      {
        "title": "Report illegal dumping",
        "reason": "A report with a location and photo.",
        "xp": "1–40"
      },
      {
        "title": "Document an obstacle on a sidewalk",
        "reason": "A useful report that can be prepared quickly.",
        "xp": "1–40"
      },
      {
        "title": "Print your own photos and give them to someone",
        "reason": "Selecting, preparing, and personally giving them counts, not the cost of the prints.",
        "xp": "1–40"
      },
      {
        "title": "Share a handmade picture or a small portion of food you cooked",
        "reason": "A small creative or practical gesture involving your own effort.",
        "xp": "1–40"
      },
      {
        "title": "Make a drawing or small portrait and give it to someone",
        "reason": "A personal gift made with a manageable amount of time.",
        "xp": "1–40"
      },
      {
        "title": "Give someone a handwritten card with personal words",
        "reason": "Individual attention with little time or material required.",
        "xp": "1–40"
      },
      {
        "title": "Give someone a plant cutting you grew yourself",
        "reason": "A small personal gesture; your care and the handover count.",
        "xp": "1–40"
      },
      {
        "title": "Collect a bag of litter in your neighborhood",
        "reason": "Visible personal effort on a manageable scale.",
        "xp": "40–80"
      },
      {
        "title": "Deliver pet food to a local animal shelter",
        "reason": "The effort and documented handover count, not the value of the food.",
        "xp": "40–80"
      },
      {
        "title": "Do grocery shopping for a neighbor",
        "reason": "Direct help requiring your own time.",
        "xp": "40–80"
      },
      {
        "title": "Give one hour of free tutoring",
        "reason": "A focused lesson without extensive preparation.",
        "xp": "40–80"
      },
      {
        "title": "Repair a small everyday device for someone",
        "reason": "Practical help using tools and technical skill.",
        "xp": "40–80"
      },
      {
        "title": "Collect and distribute food through a rescue organization",
        "reason": "Coordination with an organization and a reliable handover.",
        "xp": "80–150"
      },
      {
        "title": "Help a neighbor with gardening or moving",
        "reason": "Several hours of physical or organizational help.",
        "xp": "80–150"
      },
      {
        "title": "Run a prepared educational workshop",
        "reason": "Preparation, scheduling, and teaching several people.",
        "xp": "80–150"
      },
      {
        "title": "Lead a supervised practical beekeeping session",
        "reason": "Specialist knowledge, responsibility, and a longer personal commitment.",
        "xp": "80–150"
      },
      {
        "title": "Organize a small group litter collection",
        "reason": "Participants, supplies, and disposal must be coordinated.",
        "xp": "150–250"
      },
      {
        "title": "Sort aid supplies for a local organization",
        "reason": "Several hours of work coordinated with the organization.",
        "xp": "150–250"
      },
      {
        "title": "Offer bicycle repair help to several people",
        "reason": "Technical knowledge, supplies, and several recipients.",
        "xp": "150–250"
      },
      {
        "title": "Survey accessibility along an entire street",
        "reason": "Systematic documentation and structured reporting.",
        "xp": "150–250"
      },
      {
        "title": "Organize a group first aid refresher",
        "reason": "Organization with a qualified instructor; do not assess unqualified medical work.",
        "xp": "150–250"
      },
      {
        "title": "Provide learning support over several sessions",
        "reason": "Repeated meetings, preparation, and documented learning progress.",
        "xp": "150–250"
      },
      {
        "title": "Coordinate a donation drive for an animal shelter",
        "reason": "Several people, collection, logistics, and a documented handover.",
        "xp": "250–500"
      },
      {
        "title": "Help organize a public repair afternoon",
        "reason": "Venue, helpers, supplies, and schedule are coordinated.",
        "xp": "250–500"
      },
      {
        "title": "Organize a larger cleanup with proper disposal",
        "reason": "Substantial work with permission, a team, and organized disposal.",
        "xp": "250–500"
      },
      {
        "title": "Mentor someone in beekeeping or a craft over several weeks",
        "reason": "Sustained support with several documented sessions.",
        "xp": "250–500"
      },
      {
        "title": "Run a local education program over several sessions",
        "reason": "A plan, materials, several meetings, and measurable impact.",
        "xp": "500–800"
      },
      {
        "title": "Establish regular food rescue for an organization",
        "reason": "Create lasting processes between several organizations.",
        "xp": "500–800"
      },
      {
        "title": "Improve a shared space sustainably with permission",
        "reason": "Planning, permission, teamwork, and a lasting result.",
        "xp": "500–800"
      },
      {
        "title": "Build a neighborhood support network",
        "reason": "Several weeks of organizing helpers and recipients.",
        "xp": "500–800"
      },
      {
        "title": "Coordinate large donations of goods for several organizations",
        "reason": "Many participants, transport, sorting, and documented handovers.",
        "xp": "500–800"
      },
      {
        "title": "Complete a mentoring commitment lasting several months",
        "reason": "Long term responsibility and documented, lasting impact.",
        "xp": "500–800"
      },
      {
        "title": "Develop and introduce a nonprofit digital solution",
        "reason": "Design, implementation, introduction, and lasting use.",
        "xp": "500–800"
      },
      {
        "title": "Help someone with their training",
        "reason": "Personal assistance during a single training session.",
        "xp": "40–80"
      },
      {
        "title": "Run a shared fitness session",
        "reason": "Guide a shared exercise session and actively support others.",
        "xp": "40–80"
      },
      {
        "title": "Organize a running group",
        "reason": "Coordinate the route, timing and participants, and accompany the run.",
        "xp": "80–150"
      },
      {
        "title": "Offer free fitness training",
        "reason": "Prepare a free session adapted to the participants.",
        "xp": "80–150"
      },
      {
        "title": "Refurbish sports equipment for others",
        "reason": "Clean, refurbish and hand over equipment for use; its monetary value does not count.",
        "xp": "40–80"
      },
      {
        "title": "Run a free fitness class for several people",
        "reason": "Prepare exercises, lead the group and adapt to different abilities.",
        "xp": "150–250"
      },
      {
        "title": "Provide training support",
        "reason": "Coordinate a longer training session and reliably support someone.",
        "xp": "80–150"
      },
      {
        "title": "Organise a charitable sports activity",
        "reason": "Plan the venue, equipment, volunteers and schedule for a larger community sports event.",
        "xp": "250–500"
      },
      {
        "title": "Lead a community training session",
        "reason": "Plan and lead a longer group session and support several participants.",
        "xp": "150–250"
      },
      {
        "title": "Repair and provide sports equipment",
        "reason": "Repair defects, check usability and arrange the handover.",
        "xp": "80–150"
      },
      {
        "title": "Accompany someone to a health appointment at their request",
        "reason": "Personal accompaniment and waiting time help someone attend their appointment.",
        "xp": "40–80"
      },
      {
        "title": "Compile information on accessible advice centres for someone",
        "reason": "Brief, focused research shared clearly helps someone find appropriate support.",
        "xp": "1–40"
      },
      {
        "title": "Organise and accompany a shared walk to reduce loneliness",
        "reason": "The time, participants’ needs and a suitable route are agreed together.",
        "xp": "80–150"
      },
      null,
      null,
      {
        "title": "Run a free games or read-aloud afternoon for neighbours",
        "reason": "Preparation, invitations and hosting a group contribute to the personal effort.",
        "xp": "80–150"
      },
      {
        "title": "Organise a small free music or theatre evening for a local organisation",
        "reason": "The programme, performers, venue and schedule are coordinated with the organisation.",
        "xp": "150–250"
      },
      {
        "title": "Run a series of creative workshops open to the community",
        "reason": "Several prepared sessions, materials and facilitation require sustained effort.",
        "xp": "250–500"
      },
      {
        "title": "Mend or alter clothing for someone else",
        "reason": "Practical work extends the clothing’s useful life; effort counts rather than its monetary value.",
        "xp": "40–80"
      },
      {
        "title": "Repair and restore a donated piece of furniture for a local organisation",
        "reason": "Assessing damage, repairs and handover require tools, time and coordination.",
        "xp": "150–250"
      },
      {
        "title": "Prepare and serve a shared meal for a neighbourhood group",
        "reason": "Needs, shopping, cooking and serving are coordinated; ingredient value does not determine XP.",
        "xp": "80–150"
      },
      {
        "title": "Volunteer for a shift at a food distribution service",
        "reason": "Several hours of sorting, portioning and distribution are coordinated with the organisation.",
        "xp": "150–250"
      },
      {
        "title": "Accompany someone along an accessible everyday route",
        "reason": "The route and support needs are agreed in advance, followed by the actual accompaniment.",
        "xp": "80–150"
      },
      {
        "title": "Organise transport and handover of donated furniture for a social organisation",
        "reason": "Collection times, helpers and transport need coordination, with evidence of handover.",
        "xp": "150–250"
      },
      {
        "title": "Organise an open neighbourhood gathering for new residents",
        "reason": "Invitations, a venue and personal hosting create opportunities to meet local neighbours.",
        "xp": "80–150"
      },
      null,
      {
        "title": "Run a free orientation tour for people new to the area",
        "reason": "The route, useful local services and clear explanations are prepared in advance.",
        "xp": "150–250"
      },
      {
        "title": "Accompany participants on a club outing",
        "reason": "Coordination of meeting points, routes and individual needs makes participation possible.",
        "xp": "80–150"
      },
      {
        "title": "Take care of agreed everyday errands for someone who is temporarily unwell",
        "reason": "Practical errands reduce the person’s workload; the time actually spent is assessed.",
        "xp": "40–80"
      },
      {
        "title": "Host a free, relaxed social afternoon to reduce loneliness",
        "reason": "A venue, invitations and attentive hosting require preparation.",
        "xp": "80–150"
      },
      {
        "title": "Set up an appointment accompaniment service with a social organisation",
        "reason": "Volunteers, responsibilities and several completed accompaniment visits are coordinated.",
        "xp": "250–500"
      },
      {
        "title": "Read aloud at a free event for children",
        "reason": "Selecting and preparing stories and the actual reading time count towards the effort.",
        "xp": "40–80"
      },
      {
        "title": "Run a free creative activity station at a charity festival",
        "reason": "Materials, setup and helping several guests require personal effort.",
        "xp": "150–250"
      },
      {
        "title": "Prepare and run a public book swap",
        "reason": "Collection, sorting, venue arrangements and hosting are organised together.",
        "xp": "250–500"
      },
      {
        "title": "Supervise a free active games session for children",
        "reason": "Age-appropriate games, equipment and arrangements with the responsible adults are prepared.",
        "xp": "80–150"
      },
      {
        "title": "Support participants and activity stations at a charitable inclusive sports day",
        "reason": "Briefing, coordination and several hours of assistance help people take part.",
        "xp": "150–250"
      },
      {
        "title": "Plant and maintain a native wildflower patch with permission",
        "reason": "Site approval, suitable plants and the actual planting and maintenance work count.",
        "xp": "80–150"
      },
      {
        "title": "Help with a supervised hedgerow or traditional orchard maintenance session",
        "reason": "Several hours of practical work are coordinated with the responsible conservation group.",
        "xp": "150–250"
      },
      {
        "title": "Explain basic smartphone functions to someone",
        "reason": "Practising messages, settings or video calls together builds useful everyday skills.",
        "xp": "40–80"
      },
      {
        "title": "Give a free introduction to secure passwords and scam messages",
        "reason": "Clear examples and practical exercises are prepared for the participants.",
        "xp": "80–150"
      },
      {
        "title": "Set up used computers for a non-profit organisation",
        "reason": "Agreed data removal, installation and functional checks require time and technical skills.",
        "xp": "150–250"
      },
      {
        "title": "Repair and restore toys for another family",
        "reason": "Troubleshooting, repairs and checking usability count rather than the material value.",
        "xp": "40–80"
      },
      {
        "title": "Maintain and organise tools for a community lending service",
        "reason": "Tools are checked, maintained and organised together with the lending service.",
        "xp": "80–150"
      },
      {
        "title": "Guide a group through a simple repair",
        "reason": "Preparation and practical instruction help several people maintain their own belongings.",
        "xp": "150–250"
      },
      {
        "title": "Share surplus produce with an agreed collection point",
        "reason": "Harvesting, sorting and documented handover count; the produce’s value does not determine the points.",
        "xp": "40–80"
      },
      {
        "title": "Clean and look after a community food-sharing point",
        "reason": "Cleaning, stock checks and coordination with the responsible team require regular effort.",
        "xp": "80–150"
      },
      {
        "title": "Run a free cooking evening focused on using leftovers",
        "reason": "Recipes, ingredient arrangements and practical instruction teach useful skills to several people.",
        "xp": "150–250"
      },
      {
        "title": "Sort clothing in good condition for a community clothing service",
        "reason": "Checking, folding and organising items support their later distribution.",
        "xp": "40–80"
      },
      {
        "title": "Help with setup and distribution at a charity bazaar",
        "reason": "Equipment setup and a reliable volunteer shift are coordinated with the organising team.",
        "xp": "80–150"
      },
      {
        "title": "Introduce an organised storage and distribution system for donated goods",
        "reason": "Stocktaking, labels and team onboarding create useful ongoing processes.",
        "xp": "250–500"
      },
      {
        "title": "Help someone understand and organise official letters",
        "reason": "Reading and organising letters together helps someone navigate practical everyday tasks.",
        "xp": "40–80"
      },
      {
        "title": "Organise a free language tandem session for neighbours",
        "reason": "Agreed meeting times and prepared conversation prompts support mutual exchange.",
        "xp": "80–150"
      },
      {
        "title": "Provide agreed childcare to give a family a break",
        "reason": "Reliable childcare with the necessary arrangements gives the family practical breathing space.",
        "xp": "80–150"
      },
      {
        "title": "Supervise a children’s play corner at a neighbourhood gathering",
        "reason": "Preparation and several hours of supervision are coordinated with the responsible organisers.",
        "xp": "150–250"
      },
      {
        "title": "Prepare and run a neighbourhood swap event",
        "reason": "Needs, a venue, volunteers and actual exchanges are organised for several households.",
        "xp": "250–500"
      }
    ]
  },
  "email_confirmation": {
    "title": "Confirm email",
    "intro": "Confirm your email address to sign in.",
    "confirm": "Confirm email address",
    "success": "Your email address is confirmed. You can now sign in. Partner accounts also require admin approval.",
    "resend_link": "Request another confirmation link",
    "resend": "Send confirmation email",
    "sent": "If this address needs confirmation, an email has been sent. Please wait one minute before requesting another.",
    "registered": "Please confirm your email address using the link in your email before signing in.",
    "registered_partner": "Please confirm your email address using the link in your email. Your partner account also requires admin approval.",
    "registered_local": "Your local account is ready. You can sign in now.",
    "registered_partner_local": "Your local partner account is ready. It still requires admin approval."
  },
  "guildHeroicActions": {
    "backToActions": "Back to group good deeds",
    "category": "Category",
    "milestones": "New category milestones",
    "category_level": "Category level {{level}} reached",
    "badge_label": "{{category}} badge, level {{level}}",
    "invite": "Invite",
    "chooseMember": "Choose a member",
    "memberOption": "Member",
    "invited": "Invitation sent. The member can choose to register.",
    "title": "Group good deeds",
    "announce": "Announce good deed",
    "loadError": "Group good deeds could not be loaded.",
    "actionError": "Action failed.",
    "evidenceRequired": "Select shared evidence and confirm the privacy statement.",
    "titlePlaceholder": "Title",
    "descriptionPlaceholder": "What should the group accomplish together?",
    "declaration": "Binding organizer declaration",
    "declarations": [
      [
        "voluntaryParticipationConfirmed",
        "Participation is voluntary; members may withdraw without penalty."
      ],
      [
        "nonCommercialPurposeConfirmed",
        "The good deed serves the public good and no commercial business purpose."
      ],
      [
        "noPaidWorkReplacementConfirmed",
        "It does not replace paid employment, a work shift, or a regular service."
      ],
      [
        "safetyResponsibilityConfirmed",
        "Required permissions, safe execution, and proper disposal are organized."
      ]
    ],
    "scheduled": "Scheduled for",
    "deadline": "Sign-up deadline",
    "maxParticipants": "Max. participants",
    "announcing": "Announcing…",
    "scheduledFuture": "The scheduled time must be in the future.",
    "deadlineFuture": "The sign-up deadline must be in the future.",
    "deadlineAfterSchedule": "The sign-up deadline cannot be after the scheduled time.",
    "loading": "Loading group good deeds…",
    "empty": "No group good deed has been announced yet.",
    "registered": "registered",
    "confirmed": "confirmed",
    "groupRange": "Guideline for the whole group",
    "register": "Register",
    "allocationHint": "Allocate 100% in whole percentages among confirmed participants. No one may receive more than 50%.",
    "allocationInvalid": "Allocate exactly 100% using whole percentages. Each confirmed person may receive 0–50%; at least two people need a positive share.",
    "confirm": "Confirm participation",
    "withdraw": "Withdraw",
    "cancel": "Cancel",
    "cancelConfirmTitle": "Cancel group action?",
    "cancelConfirm": "Do you really want to cancel “{{title}}”? Invitation notifications will be removed; registered members will receive a cancellation notice.",
    "delete": "Delete",
    "deleteConfirmTitle": "Delete group action?",
    "deleteConfirm": "Do you really want to delete the cancelled group action “{{title}}”? It will disappear from the list. This cannot be undone.",
    "privacy": "The evidence does not show bystanders, license plates, private addresses, or sensitive documents.",
    "uploadLater": "Upload evidence",
    "statuses": {
      "Announced": "Registration open",
      "AwaitingEvidence": "Evidence required",
      "Returned": "Returned for revision",
      "Approved": "Verified",
      "Rejected": "Rejected",
      "Cancelled": "Cancelled"
    },
    "returnReason": "Reason for return",
    "allocationTotal": "Allocated: {{total}} / 100%",
    "chat": {
      "announced": "[HEROIC ACTION] {{title}} was announced for {{date}}. Members can now sign up.",
      "awaitingEvidence": "[HEROIC ACTION] {{title}} was completed with {{count}} confirmed participants. The shared evidence is still awaiting upload."
    }
  },
  "groupActionGuide": {
    "back": "Back to group actions",
    "title": "A group action with five people",
    "contents": "Guide contents",
    "flowTitle": "From a plan to a verified good deed",
    "absenceTitle": "If Eva does not turn up",
    "tableLabel": "Example rewards after approval",
    "buffsTitle": "How bonuses combine",
    "outcomesTitle": "Returns, rejection and completion",
    "assessmentTitle": "Additional levels for large group projects",
    "assessmentIntro": "Group actions have one additional highest level on each scale. Participant count alone does not justify a higher assessment. Documented joint effort and the actual organizational work are what count.",
    "assessmentLevels": [
      {
        "title": "Extensive team effort",
        "text": "Groups only: substantial joint work across several workdays or recurring sessions with documented contributions. Group size alone is not enough."
      },
      {
        "title": "Multi-stage organization",
        "text": "Groups only: several teams or organizations, dependent phases, clear responsibilities and coordinated handovers."
      }
    ],
    "poolComparisonTitle": "Separate bands for group pools",
    "poolComparisonColumns": [
      "Band",
      "Individual action",
      "Shared group pool"
    ],
    "poolComparisonIntro": "These defaults apply before bonuses and allocation. Group pools initially use five times the previous band values and are configured independently of individual actions. They do not automatically grow with participant count. Split equally among five people, the base share roughly matches the previous individual amount, with group buffs added on top. Larger groups receive smaller shares per person."
  },
  "presentation": {
    "welcome": "Welcome to Goodvale",
    "gameMode": "Presentation",
    "gateNames": { "community": "Realistic", "fantasy": "Fantasy" },
    "gateHint": "Click or tap once to explore. A second time confirms your choice.",
    "previewMode": "Explore {{mode}}",
    "confirmMode": "Confirm {{mode}}",
    "discoverMode": "Explore",
    "confirmPreview": "Tap or click again to confirm",
    "previewSelected": "{{mode}} enlarged. Click or tap this mode again to confirm it.",
    "title": "How would you like to experience Goodvale?",
    "hint": "You can change the appearance at any time.",
    "label": "Appearance",
    "community": "Realistic",
    "fantasy": "Fantasy",
    "communityDescription": "Do good together. Clear categories, groups, and personal progress.",
    "fantasyDescription": "Experience good deeds as an adventure with classes, guilds, and fantasy artwork.",
    "saving": "Saving appearance …",
    "error": "This appearance applies on this device. Saving it to your account is still pending.",
    "retry": "Save again",
    "unsupported": "This appearance is not available here yet. Realistic mode is shown temporarily; your account preference is preserved.",
    "loading": "Loading appearance …",
    "invalid": "This appearance is unavailable.",
    "saved": "Appearance saved.",
    "choose": "Choose appearance",
    "login": "Log in",
    "legal": "Legal information",
    "loadError": "Your account preference could not be loaded. Please try again.",
    "reload": "Load again"
  },
  "effectDescriptions": {
    "ParallelHeroicActionSlot": "{{value}} additional parallel submission slot.",
    "HeroicActionCooldownReduction": "{{percent}}% shorter waiting time between submissions.",
    "WeeklyCooldownSkip": "Skip the waiting time once per calendar week. A free submission slot is still required.",
    "HeroicActionRepair": "Revise one rejected individual deed of your own once and resubmit it for review."
  },
  "effectTitles": {
    "CategoryRewardBonus": "Category bonus",
    "CategoryExperienceBonus": "Category experience",
    "GuildGildexContributionBonus": "Group contribution",
    "HeroicActionXpBonus": "Experience bonus",
    "PartyBuff": "Group bonus",
    "ParallelHeroicActionSlot": "Additional slot",
    "HeroicActionCooldownReduction": "Shorter waiting time",
    "KarmaBonus": "Trust bonus",
    "GroupKarmaBonus": "Group trust",
    "KarmaRecoveryBonus": "Rebuild trust",
    "OtherCategoryExperienceBonus": "Versatility",
    "WeeklyCooldownSkip": "Skip waiting time",
    "WeeklyExperienceElixir": "Experience bonus",
    "HeroicActionRepair": "Revise once",
    "ClassKarmaRecovery": "Rebuild trust"
  },
  "unlocks": {
    "TROPHY_ROOM": {
      "description": "Unlocks an internal gallery for successfully completed and verified group good deeds."
    }
  },
  "classAvailability": {
    "contacts": "Good Contacts",
    "repair": "Revise once",
    "available": "Available",
    "unavailable": "Unavailable",
    "used": "Used",
    "again": "Available again",
    "how": "How {{label}} works",
    "contactsHelp": [
      "Free one active cooldown slot per calendar week.",
      "Open My slots and select Free slot on the cooldown card.",
      "The slot becomes available immediately. The week resets Monday at 00:00 UTC."
    ],
    "bonusHelp": [
      "Once per calendar week, earn {{percent}}% additional total and category experience for one approved individual deed.",
      "Select it in the last submission step or in quick submission.",
      "Used on submission, even if later rejected. The week resets Monday at 00:00 UTC."
    ],
    "repairHelp": [
      "Revise one of your rejected individual deeds once and resubmit it for review.",
      "Open its details and choose the revision option.",
      "Change the description or evidence; a free submission slot is required. Other rejected deeds remain eligible."
    ]
  },
  "category_detail": {
    "subtitle": "Your contributions in this category",
    "intro": "Explore your submissions and ideas for your next good deed with estimated XP ranges.",
    "back": "Back to dashboard",
    "submissions": "Your submissions",
    "all": "View all",
    "empty": "You have not submitted any good deeds in this category yet. Get inspired by the examples.",
    "pagination": "Submission pages",
    "previous": "Previous",
    "next": "Next",
    "page": "Page {{page}} of {{pages}}"
  }
}
